export const locale = {
  accepted: "Đã chấp nhận",
  acceptedByDian: "Đã được Dian chấp nhận",
  accessControl: "Kiểm soát ra vào",
  accessControlSidebar: "Kiểm soát ra vào",
  accessControlReport: "Báo cáo kiểm soát ra vào",
  accessControlRoleAppDesc: "Vai trò này không có quyền truy cập trang web.",
  accessControlRoleDashboardDesc: "Cho phép truy cập chức năng Kiểm tra ra vào trên ứng dụng.",
  accessInOut: "Vào/Ra",
  accessKey: "Khóa truy cập",
  accessPoint: "Điểm ra vào",
  accessPointCreateSuccess: " Tạo điểm ra vào thành công",
  accessPointExisted: "Điểm ra vào này đã tồn tại. Vui lòng chọn tên khác",
  accessPointName: "Tên điểm ra vào",
  accessToken: "Mã truy cập (Access Token)",
  accessURLOrQRCode: "URL truy cập hoặc mã QR",
  accommodation: "Chỗ ở",
  account: "Tài khoản",
  accountAlreadyExists: "Email này đã được liên kết với một tài khoản tại địa điểm này",
  accountCantSeemToFind: "Rất tiếc! Chúng tôi không tìm thấy tài khoản của bạn. Vui lòng liên hệ quản lý địa điểm để được hỗ trợ.",
  accountCode: "Mã tài khoản",
  accountCodeAddedName: "Đã thêm mã tài khoản “{0}“.",
  accountCodeAlreadyExist: "Mã tài khoản đã tồn tại.",
  accountEmailAdded: "Đã thêm tài khoản “{0}“.",
  accountEmailRemoved: "Đã xóa tài khoản “{0}“.",
  accountingSoftware: "Phần mềm kế toán",
  accountIsActive: "Tài khoản đang hoạt động",
  accountMapping: "Liên kết tài khoản",
  accountMappingDescription: "Thiết lập và liên kết tài khoản của bạn với hệ thống SoCashlessVENUE.",
  accountName: "Tên tài khoản",
  accountNotFound: "Không tìm thấy tài khoản",
  accounts: "Tài khoản",
  accountSettings: "Cài đặt tài khoản",
  accountType: "Loại tài khoản",
  accrNo: "Số Accr#:",
  actions: "Thao tác",
  activateInPos: "Kích hoạt trên POS",
  activateOnOnlineMenu: "Kích hoạt trên thực đơn trực tuyến",
  activateOnPOS: "Kích hoạt trên máy bán hàng (POS)",
  activateOnPos: "Kích hoạt trên máy bán hàng (POS)",
  activateVariant: "Kích hoạt biến thể",
  active: "Đang hoạt động",
  activeDateRange: "Khoảng thời gian hiệu lực",
  actualClosingBalance: "Số dư cuối ca thực tế",
  actualQty: "SL thực tế",
  actualStockQty: "SL tồn kho thực tế",
  add: "Thêm",
  addAccount: "Thêm tài khoản",
  addAndManageAdditionalCharge: "Thêm và quản lý các khoản phụ phí khi bán trên POS.",
  addANote: "Thêm ghi chú...",
  addAnotherAccount: "Thêm tài khoản khác",
  addAnotherAttribute: "Thêm thuộc tính khác",
  addAnotherProductOrSupplyItem: "Thêm mặt hàng hoặc hàng tồn kho khác",
  addAnotherSupplyItem: "Thêm hàng tồn kho khác",
  addAProduct: "Thêm một mặt hàng",
  addASupplyItem: "Thêm một hàng tồn kho",
  addAValidAttributeAndOptions: "Thêm thuộc tính và tùy chọn hợp lệ.",
  addAWholeProduct: "Thêm một mặt hàng hoàn chỉnh",
  addCharge: "Thêm phụ phí",
  addCustomQuestion: "Thêm câu hỏi tùy chỉnh",
  addedStock: "Tồn kho đã thêm",
  additionalChargeReport: "Báo cáo phụ phí",
  addValidAttributeAndOptions: "Thêm thuộc tính và tùy chọn hợp lệ",
  allDay: "Cả ngày",
  allDays: "Tất cả các ngày",
  allItems: "Tất cả mặt hàng",
  allPaymentTypes: "Tất cả loại thanh toán",
  apiInformation: "Thông tin API",
  avgAmount: "Số tiền trung bình",
  byCategory: "Theo danh mục",
  byGuest: "Theo khách",
  byItem: "Theo mặt hàng",
  byLocation: "Theo vị trí",
  byStaff: "Theo nhân viên",
  changeRevenueAccount: "Đổi tài khoản doanh thu",
  checkoutCreditsReturned: "Tín dụng hoàn trả khi trả phòng",
  checkoutPaymentCollected: "Thanh toán thu khi trả phòng",
  cloudbedsDescription: "Quản lý cơ sở lưu trú, tập trung dữ liệu lễ tân và khách hàng tại một nơi.",
  cloudbedsPropertyName: "Tên cơ sở Cloudbeds",
  completeThisIntegrationByAssigning: "Hoàn tất tích hợp này bằng cách gán điểm bán/dịch vụ trong phần cấu hình bên dưới.",
  completeThisIntegrationByAssigningShort: "Hoàn tất tích hợp này bằng cách gán điểm bán/dịch vụ trong phần cấu hình.",
  contactUsAction: "Liên hệ với chúng tôi",
  coordinates: "Tọa độ",
  costOfGoods: "Giá vốn hàng bán",
  creditExpirationOnCheckout: "Tín dụng hết hạn khi trả phòng",
  creditFlow: "Dòng tín dụng",
  creditStatus: "Trạng thái tín dụng",
  creditsKeptOutlet: "Điểm bán giữ tín dụng",
  creditsReceivedOutlet: "Điểm bán nhận tín dụng",
  customIntegrations: "Tích hợp tùy chỉnh",
  denominationGroupDescription: "Nhóm mệnh giá này sẽ là các lựa chọn có sẵn trên màn hình Nạp tiền của ứng dụng Venue.",
  detailedAccessControl: "Kiểm soát ra vào chi tiết",
  duplication: "Trùng lặp",
  eatAppDescription: "Đặt bàn, quản lý bàn và hồ sơ khách cho các nhà hàng đông khách.",
  eatAppId: "ID Eat App",
  editOutletsAndService: "Sửa điểm bán và dịch vụ",
  editRevenueAccount: "Sửa tài khoản doanh thu",
  enterEatAppRoomId: "Nhập ID phòng Eat App",
  enterEatAppRoomIdToMap: "Nhập ID phòng Eat App để liên kết với hồ sơ khách này.",
  erpAndAccounting: "ERP và kế toán",
  errorProcessingProductData: "Lỗi xử lý dữ liệu mặt hàng. Vui lòng thử lại.",
  eventEndDate: "Ngày kết thúc sự kiện",
  eventId: "ID sự kiện",
  eventName: "Tên sự kiện",
  eventStartDate: "Ngày bắt đầu sự kiện",
  exportFailed: "Xuất dữ liệu thất bại",
  externalTicketId: "ID vé bên ngoài",
  feesAndSurcharges: "Phí & phụ thu",
  additionalCharges: "Phụ phí",
  addNewAccount: "Thêm tài khoản mới",
  addNewAccountCode: "Thêm mã tài khoản mới",
  addNewAccountCodeName: "Thêm mã tài khoản mới “{0}”",
  addNewPaymentMethod: "Thêm phương thức thanh toán mới",
  addNewSupplyItem: "Thêm hàng tồn kho mới",
  addNewSupplyItemSelect: "Thêm hàng tồn kho mới “{0}”",
  addNewTax: "Thêm thuế mới",
  addNote: "Thêm ghi chú",
  addOption: "Thêm tùy chọn",
  addOptions: "Thêm các tùy chọn",
  addPaymentGateway: "Thêm cổng thanh toán",
  addPaymentMethod: "Thêm phương thức thanh toán",
  addProduct: "Thêm mặt hàng",
  addProductLimit: "Để thêm mặt hàng, hãy xóa bớt một số mặt hàng hoặc đề nghị Chủ địa điểm tăng giới hạn mặt hàng!",
  addProductLimitOwner: "Để thêm mặt hàng, hãy xóa bớt một số mặt hàng hoặc nâng cấp gói để tăng giới hạn mặt hàng!",
  addProducts: "Thêm mặt hàng hoặc hàng tồn kho vào bộ mặt hàng này.",
  addQty: "Thêm SL",
  addStaffLimit: "Để thêm nhân viên, hãy xóa bớt một số nhân viên hoặc đề nghị Chủ địa điểm tăng giới hạn nhân viên!",
  addStaffLimitOwner: "Để thêm nhân viên, hãy xóa bớt một số nhân viên hoặc nâng cấp gói để tăng giới hạn nhân viên!",
  addSupplyItem: "Thêm hàng tồn kho",
  addThisProduct: "Thêm mặt hàng này thành mặt hàng và hàng tồn kho mới.",
  addVariant: "Thêm biến thể",
  adjustQuantity: "Điều chỉnh số lượng",
  adjustStockSuccessfully: "Điều chỉnh tồn kho thành công",
  adjustTheSupplyItemsVariant: "Điều chỉnh hàng tồn kho và số lượng cho biến thể cụ thể này.",
  advancedReporting: "Báo cáo nâng cao",
  all: "Tất cả",
  allAccessPoints: "Tất cả điểm ra vào",
  allAccountTypes: "Tất cả loại tài khoản",
  allCategories: "Tất cả danh mục",
  allDevices: "Tất cả thiết bị",
  allDevicesUsed: "Tất cả thiết bị đã dùng",
  allDiscounts: "Tất cả giảm giá",
  allGuestProfiles: "Tất cả hồ sơ khách",
  allLocation: "Tất cả vị trí",
  allLocations: "Tất cả vị trí",
  allMeasurements: "Tất cả đơn vị đo",
  allowAccess: "Cho phép truy cập",
  allowAccessAndConnect: "Cho phép truy cập và kết nối",
  allowAndSetTip: "Cho phép tiền tip và đặt tỷ lệ phần trăm",
  allowBargainDesc: "Khi chọn mục này, nhân viên có thể thay đổi giá mặt hàng trên POS",
  allowBargainOnThisProduct: "Cho phép mặc cả mặt hàng này",
  allowCustomTip: "Cho phép khách tự nhập tiền tip",
  allowedAccessPoint: "Điểm ra vào được phép",
  allowedGuestProfile: "Hồ sơ khách được phép",
  allowedPaymentMethod: "Phương thức thanh toán được phép",
  allowGuestProfile: "Cho phép hồ sơ khách",
  allowGuestWBKeeping: "Cho phép khách giữ lại thẻ khi trả phòng.",
  allowInstallationFromUnknownSources: "Cho phép cài đặt từ nguồn không xác định",
  allowInstallationFromUnknownSourcesDesc: "Bạn có thể cần bật cài đặt này trong phần bảo mật của thiết bị để cài ứng dụng ngoài kho ứng dụng chính thức. Các bước cụ thể có thể khác nhau tùy theo hệ điều hành của thiết bị",
  allowOrRestrictGuestWBKeeping: "Cho phép hoặc hạn chế khách giữ lại thẻ khi trả phòng.",
  allowPostpaidAndLimit: "Cho phép tín dụng trả sau và đặt hạn mức.",
  allowPostpaidInGuestProfile: "Cho phép hồ sơ khách này mua hàng mà không cần tín dụng. Khách sẽ bị tính phí khi trả phòng/rời địa điểm.",
  allowThisGuestProfileLimit: "Cho phép hồ sơ khách này mua hàng mà không cần tín dụng. Khách sẽ bị tính phí khi trả phòng/rời địa điểm.",
  allPaymentMethods: "Tất cả phương thức thanh toán",
  allProducts: "Tất cả mặt hàng",
  allReportsReadyForDownload: "Tất cả báo cáo đã sẵn sàng để tải xuống",
  allResponse: "Tất cả phản hồi",
  allRightsReserved: "Bảo lưu mọi quyền.",
  allRoles: "Tất cả vai trò",
  allSafeToDeleteLocation: "An toàn! Không có mặt hàng nào ở vị trí này.",
  allSelectedAvailablePos: "Tất cả mặt hàng đã chọn sẽ có sẵn trên POS.",
  allSelectedNotPos: "Tất cả mặt hàng đã chọn sẽ không hiển thị trên POS.",
  allShiftsClosed: "Tất cả ca đã đóng",
  allSources: "Tất cả nguồn",
  allStaff: "Tất cả nhân viên",
  allState: "Tất cả trạng thái",
  allStatus: "Tất cả trạng thái",
  allExternalPayments: "Tất cả",
  allStockLevels: "Tất cả mức tồn kho",
  allTransactions: "Tất cả giao dịch",
  allTransactionTypes: "Tất cả loại giao dịch",
  allVenues: "Tất cả địa điểm",
  allVouchers: "Tất cả voucher",
  allVoucherTypes: "Tất cả loại voucher",
  almostThere: "Sắp xong rồi!",
  alreadyExists: "Đã tồn tại.",
  amount: "Số tiền",
  and: "và",
  andManyMore: "và nhiều hơn nữa!",
  andWouldBe: "và sẽ là",
  anHourAgo: "một giờ trước",
  anyMoreQuestions: "Còn câu hỏi nào khác? {0}",
  appDate: "Ngày cài đặt / cập nhật ứng dụng",
  applyFilter: "Áp dụng bộ lọc",
  appReinstall: "Cài lại ứng dụng",
  appVersion: "Phiên bản ứng dụng",
  areYouSureSentToDian: "Bạn có chắc muốn gửi hóa đơn này tới Dian? Vui lòng kiểm tra lại người nhận trước khi tiếp tục.",
  areYouSureYouWantToDeleteCharge: "Bạn có chắc muốn xóa khoản phụ phí {0}",
  areYouSureYouWantToDeleteLocation: "Bạn có chắc muốn xóa {0}? Vị trí này hiện có giá trị tồn kho là {1}.",
  areYouSureYouWantToDeletePaymentGatewaySetting: "Bạn có chắc muốn xóa “{0}”? Cổng này sẽ không còn trong cài đặt thanh toán của bạn.",
  areYouSureYouWantToDeleteProduct: "Bạn có chắc muốn xóa {0}? Hàng tồn kho này hiện còn {1} {2} trong kho.",
  areYouSureYouWantToDeleteProduct2: "Bạn có chắc muốn xóa {0}? Mặt hàng này sẽ không còn tại địa điểm của bạn. Các giao dịch và báo cáo trước đó sẽ không bị ảnh hưởng.",
  areYouSureYouWantToRemoveVariant: "Bạn có chắc muốn xóa biến thể “{0}”? Hàng tồn kho của biến thể sẽ không bị xóa.",
  areYouSureYouWantToSetAsDefaultPaymentGatewaySetting: "Bạn có chắc muốn đặt “{0}” làm cổng thanh toán mặc định?",
  arrivalDate: "Ngày đến",
  arrivals: "Khách đến",
  askDeleteGuestProfile: "Xóa hồ sơ khách?",
  askDeleteStaffProfile: "Xóa hồ sơ nhân viên?",
  askGuestInfoCheckIn: "Hỏi thông tin khách khi nhận phòng/check-in.",
  askVenueOwnerToUpgradePlan: "Đề nghị chủ địa điểm nâng cấp gói để bắt đầu sử dụng tính năng này.",
  askYourAdminToUpdateAccess: "Nếu bạn cần truy cập trang quản trị, vui lòng đề nghị quản trị viên cập nhật quyền truy cập.",
  assemble: "Lắp ráp",
  assembleAProduct: "Lắp ráp một mặt hàng",
  asset: "Tài sản",
  assignAProfile: "Gán hồ sơ",
  assignedRooms: "Phòng/Giường đã gán",
  assignedSpace: "Khu vực đã gán",
  assignFreeCreditsStaff: "Gán tín dụng miễn phí cho nhân viên trong nhóm này",
  assignVoucherStaff: "Gán voucher cho nhân viên trong nhóm này",
  assignVoucherToGuest: "Gán voucher cho khách trong nhóm này khi đăng ký.",
  atLeast1GuestProfile: "Cần ít nhất 1 hồ sơ khách",
  attribute: "Thuộc tính",
  attributeAlreadyExists: "Tên thuộc tính đã tồn tại trong mặt hàng này",
  automaticallyAddThisChargeToTheCart: "Tự động thêm phụ phí này vào giỏ hàng?",
  automaticallyAddThisChargeToTheCartDesc: "Khi mặt hàng đầu tiên được thêm vào giỏ, phụ phí này sẽ tự động được thêm. Nhân viên có thể xóa phụ phí này.",
  automaticallyGenerateSku: "Tự động tạo SKU",
  availability: "Tình trạng khả dụng",
  availabilityOnPos: "Khả dụng trên POS",
  available: "Khả dụng",
  availableAnytime: "Khả dụng mọi lúc",
  availableEveryday: "Khả dụng hằng ngày",
  availableOnPos: "Khả dụng trên máy bán hàng (POS)",
  averageAmountPerItem: "Số tiền TB mỗi mặt hàng",
  averageDurationOfStay: "Thời gian lưu trú trung bình",
  averageOrderValue: "Giá trị đơn hàng trung bình",
  awaiting: "Đang chờ",
  awaitingInviteResponse: "Đang chờ phản hồi lời mời.",
  aWholeProductIsFinished: "Mặt hàng hoàn chỉnh là thành phẩm được bán tại địa điểm của bạn. Với biến thể, bạn có thể bán các phiên bản khác nhau của mặt hàng này như hương vị, màu sắc và kích cỡ. Mỗi mặt hàng hoàn chỉnh và các biến thể của nó sẽ có hàng tồn kho riêng.",
  back: "Quay lại",
  backOffice: "Văn phòng",
  backOfficeRoleAppDesc: "Vai trò này không có quyền liên quan đến ứng dụng và sẽ không thể đăng nhập trên thiết bị.",
  backOfficeRoleDashboardDesc: "Cho phép truy cập Thống kê, Bán hàng, Nhân viên, Hồ sơ khách, Voucher, Giảm giá, Hồ sơ máy in và Cài đặt trên trang quản trị",
  balance: "Số dư",
  balanceMovementsDescription: "Xem số dư của khách đến từ địa điểm nào trong nhóm địa điểm",
  balanceMovementsIn: "Biến động số dư vào",
  balanceMovementsInPage: "Biến động số dư vào",
  balanceMovementsOut: "Biến động số dư ra",
  balanceMovementsOutPage: "Biến động số dư ra",
  banATag: "Chặn một thẻ",
  blockATag: "Chặn một thẻ",
  banDetails: "Chi tiết chặn",
  banList: "Danh sách chặn",
  blockedTags: "Thẻ bị chặn",
  bannedBy: "Bị chặn bởi",
  blockedBy: "Bị chặn bởi",
  bannedTags: "Thẻ bị chặn",
  banningThisTagWillOnlyTakeEffect: "Việc chặn thẻ này chỉ có hiệu lực ở lần đồng bộ và cập nhật thiết bị tiếp theo (thường mỗi 5 phút khi có kết nối internet). Để áp dụng ngay, vui lòng đồng bộ và cập nhật thiết bị sau khi chặn thẻ.",
  banTag: "Chặn thẻ",
  banTagListSettings: "Cài đặt danh sách thẻ bị chặn",
  banTags: "Chặn thẻ",
  bargainAllowed: "Cho phép mặc cả",
  bargainRequiresApproval: "Mặc cả cần phê duyệt",
  bargainRequiresApprovalOnThisProduct: "Yêu cầu quản lý phê duyệt khi thay đổi giá mặt hàng này trên POS",
  basicInfo: "Thông tin cơ bản",
  beforeUpdatingTheAppPleaseEnsureAllDataIsSyncedBy: "Trước khi cập nhật ứng dụng, vui lòng đảm bảo mọi dữ liệu đã được đồng bộ bằng cách:",
  belowParLevel: "Dưới mức tồn tối thiểu",
  billAmount: "Số tiền hóa đơn",
  billedTo: "Thanh toán cho",
  birthdate: "Ngày sinh",
  birthday: "Sinh nhật",
  bookedBy: "Người đặt",
  bookingAccomodation: "Chỗ ở đã đặt",
  bookingAmount: "Số tiền đặt chỗ",
  bookingDescription: "Theo dõi mọi lượt đặt chỗ tại địa điểm của bạn.",
  bookingDetails: "Chi tiết đặt chỗ",
  bookingGuests: "Khách đặt chỗ",
  bookingId: "Mã đặt chỗ",
  bookingList: "Danh sách đặt chỗ",
  bookingNo: "Số đặt chỗ",
  bookingPrice: "Giá đặt chỗ",
  bookings: "Đặt chỗ",
  finishIntegration: "Hoàn tất tích hợp",
  firmware: "Firmware",
  fixed: "Cố định",
  friday: "Thứ Sáu",
  fromThisArticle: "từ bài viết này",
  fullLabel: "Đầy đủ",
  grossMargin: "Biên lợi nhuận gộp",
  hereAreSomeTroubleshootingSteps: "Dưới đây là một số bước khắc phục sự cố.",
  howToFindYourAccessToken: "Cách tìm mã truy cập (Access Token)",
  imei: "IMEI",
  lastLocation: "Vị trí cuối cùng",
  lastSeen: "Lần cuối hoạt động",
  linkedService: "Dịch vụ đã liên kết",
  lobbyDescription: "Phần mềm quản lý cho khách sạn, hostel, glamping và nhà nghỉ.",
  mapLoadingError: "Lỗi tải bản đồ",
  mappingGuestProfileWithEatApp: "Liên kết hồ sơ khách với Eat App",
  maxAmount: "Số tiền tối đa",
  mewsAccountingIntegrationRequirements: "Yêu cầu tích hợp kế toán MEWS",
  mewsDashboard: "Trang quản trị MEWS",
  mewsDescription: "Đơn giản hóa và tự động hóa vận hành hằng ngày cho khách sạn hiện đại.",
  mewsDisconnectionMessage: "Bạn có chắc muốn ngắt kết nối với Mews? Tích hợp này và toàn bộ thông tin Mews sẽ bị xóa khỏi địa điểm của bạn.",
  mewsInstructionStep1: "1. Truy cập",
  mewsInstructionStep2: "2. Vào Main Menu > Marketplace.",
  mewsInstructionStep3: "3. Tìm “SoCashless”, nhấn “Explore” rồi “Connect Integration”. Nếu SoCashless đã được kết nối, chuyển sang bước tiếp theo.",
  mewsInstructionStep4: "4. Tìm “SoCashless” trong My Subscriptions và nhấn Edit.",
  mewsInstructionStep5End: "ở góc trên bên phải, sau đó sao chép mã truy cập.",
  mewsInstructionStep5Start: "5. Nhấn biểu tượng chìa khóa",
  mewsOutletSyncDescription: "Mọi giao dịch được đồng bộ tới các điểm bán (outlet) cụ thể trong MEWS tùy theo loại giao dịch. Chúng tôi khuyến nghị tạo các outlet mới dành riêng cho giao dịch thực hiện qua ứng dụng. Để biết cách tạo outlet trong MEWS, hãy làm theo bước \"Create an outlet\"",
  mewsPropertyName: "Tên cơ sở MEWS",
  mewsServiceSyncDescription: "Mọi giao dịch được đồng bộ cần liên kết với một dịch vụ \"Additional\" được tạo trong MEWS. Chúng tôi khuyến nghị tạo một dịch vụ mới để liên kết giao dịch thực hiện qua ứng dụng. Để biết cách tạo dịch vụ bổ sung trong MEWS, hãy làm theo bước \"Create an additional service\"",
  mewsTroubleshootingStep1Desc: "Đảm bảo trạng thái tích hợp kế toán MEWS của bạn không phải là \"Kết nối một phần\". Nếu trang tích hợp hiển thị trạng thái này, nghĩa là bạn chưa cấu hình Điểm bán và Dịch vụ. Nhấn nút \"Hoàn tất tích hợp\" để hoàn thành quá trình tích hợp.",
  mewsTroubleshootingStep1Title: "Bước 1: Cấu hình điểm bán và dịch vụ",
  mewsTroubleshootingStep2DescEnd: "hướng dẫn bạn các bước để thực hiện.",
  mewsTroubleshootingStep2DescStart: "Vì ứng dụng hoạt động ở chế độ kết hợp (ngoại tuyến và trực tuyến), cần đảm bảo giao dịch vẫn được đồng bộ tới MEWS ngay cả khi mất kết nối mạng trong thời gian dài. Do đó, chúng tôi khuyến nghị đặt \"Accounting editable history window\" thành 7 ngày trong cài đặt MEWS.",
  mewsTroubleshootingStep2Title: "Bước 2: Chỉnh sửa Accounting Editable History Window",
  mewsTroubleshootingStep3DescMiddle: "trùng với đơn vị tiền tệ được cấu hình trong tài khoản MEWS của bạn",
  mewsTroubleshootingStep3DescStart: "Đảm bảo đơn vị tiền tệ được đặt trong trang quản trị địa điểm",
  mewsTroubleshootingStep3Hint1: "(bạn có thể tìm tại Cài đặt > Chung)",
  mewsTroubleshootingStep3Hint2: "(Settings > Property > Globalization > Default Currency)",
  mewsTroubleshootingStep3Title: "Bước 3: Kiểm tra cài đặt tiền tệ",
  mewsTroubleshootingStep4Desc: "Các giao dịch không liên kết với khách trong MEWS sẽ được đồng bộ sau khi bạn thực hiện quy trình Chốt cuối ngày. Chúng tôi khuyến nghị chạy Chốt cuối ngày ít nhất một lần mỗi ngày.",
  mewsTroubleshootingStep4Title: "Bước 4: Đảm bảo đã chạy Chốt cuối ngày",
  mewsTroubleshootingSteps: "Các bước khắc phục sự cố MEWS",
  minAmount: "Số tiền tối thiểu",
  monday: "Thứ Hai",
  needSomethingElse: "Cần hỗ trợ thêm?",
  noDataMatchesTheseFilters: "Không có dữ liệu khớp với bộ lọc.",
  noDevicesAvailable: "Không có thiết bị nào",
  noPaymentGatewaysFound: "Không tìm thấy cổng thanh toán",
  notAvailable: "Không có",
  noValidMapCoordinates: "Không tìm thấy tọa độ bản đồ hợp lệ cho thiết bị đã chọn.",
  nttDataDescription: "Thanh toán thẻ và xử lý giao dịch tại địa điểm.",
  numberAbbr: "Số",
  odooDescription: "Bộ ERP mã nguồn mở bao gồm kế toán, kho hàng và mua hàng.",
  overTime: "Theo thời gian",
  partiallyConnected: "Kết nối một phần",
  paymentGateway: "Cổng thanh toán",
  paymentGateways: "Cổng thanh toán",
  peakHours: "Giờ cao điểm",
  permBasicVenueInformation: "Thông tin cơ bản của địa điểm",
  permBookingsAndGuestDetails: "Đặt chỗ và thông tin khách",
  permCustomPaymentMethod: "Phương thức thanh toán tùy chỉnh",
  permHouseAccount: "Tài khoản nội bộ",
  permSaleTransactions: "Giao dịch bán hàng",
  pleaseSelectAtLeastOneRole: "Vui lòng chọn ít nhất một vai trò.",
  productHasVariantsEditPriceInDetail: "Mặt hàng này có biến thể, vui lòng vào chi tiết mặt hàng để sửa giá",
  propertyManagementSystems: "Hệ thống quản lý cơ sở lưu trú",
  refundClaimEndDate: "Ngày kết thúc yêu cầu hoàn tiền",
  refundClaimStartDate: "Ngày bắt đầu yêu cầu hoàn tiền",
  registeredLabel: "Đã đăng ký",
  reservations: "Đặt chỗ",
  frontOfHouse: "Tiền sảnh",
  bookingStatus: "Trạng thái đặt chỗ",
  bookingSummary: "Tóm tắt đặt chỗ",
  bottle: "chai",
  browseProducts: "Duyệt mặt hàng",
  browseVouchers: "Duyệt voucher",
  businessAddress: "Địa chỉ doanh nghiệp",
  businessContactNumber: "Số điện thoại doanh nghiệp",
  businessDay: "Ngày kinh doanh",
  businessDetails: "Thông tin doanh nghiệp",
  businessName: "Tên doanh nghiệp",
  byAssemblingAProduct: "Bằng cách lắp ráp mặt hàng, bạn có thể tạo mặt hàng từ nhiều hàng tồn kho cũng như tách một hàng tồn kho thành nhiều biến thể.",
  byCreatingPrinterProfiles: "Bằng cách tạo hồ sơ máy in, bạn có thể chọn mặt hàng nào được in trên phiếu order cho từng khu vực như bếp, quầy bar, v.v.",
  cacheCleared: "Đã xóa bộ nhớ đệm",
  cancel: "Hủy",
  cancelBanTag: "Hủy chặn thẻ",
  cancelCloseShift: "Hủy đóng ca",
  cancelled: "Đã hủy",
  cannotBeDeleted: "Không thể xóa.",
  cannotDeletePartOfComposite: "Không thể xóa {0} vì nó là thành phần của {1} {2} tổng hợp.",
  cantFindDesc: "Không tìm thấy thứ bạn cần? Hãy thử tìm kiếm hoặc bộ lọc khác.",
  capacity: "Sức chứa",
  card: "Thẻ",
  cardApprovalNumber: "Mã phê duyệt thẻ",
  cardNumber: "Số thẻ",
  cash: "Tiền mặt",
  cashlessTransactionsWithDoor: "giao dịch không tiền mặt kèm mở khóa cửa! ",
  cashSales: "Doanh thu tiền mặt",
  categories: "Danh mục",
  categoriesDeleted: "Đã xóa {0} danh mục.",
  categorizeAndManage: "Phân loại và quản lý mọi giao dịch với hệ thống tài khoản.",
  category: "Danh mục",
  categoryCreated: "Đã tạo danh mục \"{0}\".",
  categoryDeleted: "Đã xóa danh mục \"{0}\".",
  categoryList: "Danh sách danh mục",
  categoryName: "Tên danh mục",
  categoryNameAlreadyExist: "Tên danh mục đã tồn tại.",
  categoryNameReserved: "Tên danh mục đã được dành riêng. Vui lòng dùng tên khác.",
  categoryReport: "Báo cáo danh mục",
  categoryUpdated: "Đã cập nhật danh mục \"{0}\".",
  change: "Thay đổi",
  changelog: "Nhật ký thay đổi",
  changePassword: "Đổi mật khẩu",
  changePhoto: "Đổi ảnh",
  changesSaved: "Đã lưu thay đổi.",
  changesSavedSuccessfully: "Lưu thay đổi thành công",
  changingCurrencyWontAffect: "Thay đổi tiền tệ sẽ không ảnh hưởng đến giá trị của mặt hàng, chỉ thay đổi ký hiệu tiền tệ.",
  charge: "Phụ phí",
  chargeAmount: "Số tiền phụ phí",
  chargeCalculation: "Cách tính phụ phí",
  chargeDeleted: "Đã xóa phụ phí {0}",
  chargeItem: "Khoản phụ phí",
  chargeName: "Tên phụ phí",
  chargeTaxesOnThisProduct: "Tính thuế cho mặt hàng này",
  chartOfAccounts: "Hệ thống tài khoản",
  chartOfAccountsDescription: "Cập nhật và quản lý hệ thống tài khoản của bạn.",
  checkbox: "Hộp chọn",
  checkedIn: "Đã check-in",
  checkedInBy: "Check-in bởi",
  checkedInDate: "Ngày check-in",
  checkedOut: "Đã check-out",
  checkedOutBy: "Check-out bởi",
  checkedOutDate: "Ngày check-out",
  checkedOutOn: "Check-out lúc",
  checkinAmount: "Số tiền check-in",
  checkInDate: "Ngày check-in",
  checkInDetails: "Chi tiết check-in",
  checkingYourInternet: "Kiểm tra kết nối internet hoặc dữ liệu di động.",
  checkinId: "Mã check-in",
  checkInQuestions: "Câu hỏi check-in",
  checkIns: "Lượt check-in",
  checkInSettings: "Cài đặt check-in",
  checkout: "Check-out",
  checkOutDetails: "Chi tiết check-out",
  checkoutOurEbook: "Hãy xem thêm ebook của chúng tôi về cách tối ưu địa điểm của bạn!",
  checkOuts: "Lượt check-out",
  checkOutTheGuide: "Xem hướng dẫn kết nối tích hợp.",
  checkStocks: "Kiểm tra tồn kho",
  checkYourEmail: "Kiểm tra email của bạn",
  checkYourEmailAt: "Kiểm tra email tại {0} để hoàn tất thiết lập tài khoản.",
  checkYourEmailOrAdmin: "Kiểm tra email hoặc liên hệ quản trị viên.",
  chooseAInventoryGroup: "Chọn nhóm kho hàng",
  chooseAPassword: "Sử dụng mật khẩu mạnh mà bạn không dùng ở nơi khác.",
  chooseAPaymentMethod: "Chọn phương thức thanh toán",
  chooseAReason: "Chọn lý do",
  chooseASaleTax: "Chọn thuế bán hàng",
  chooseASimpleOrMultipleItem: "Chọn một hoặc nhiều hàng tồn kho để tạo mặt hàng.",
  chooseAtleast1Location: "Chọn ít nhất 1 vị trí",
  chooseAVenue: "Chọn địa điểm",
  chooseCategoryColor: "Chọn màu danh mục:",
  chooseColumns: "Chọn các cột bạn muốn xem trong báo cáo này.",
  chooseInformation: "Chọn thông tin cần đưa vào bảng phân tích doanh thu.",
  chooseLocationForThisStaff: "Chọn vị trí làm việc cho nhân viên này",
  choosePassword: "Chọn mật khẩu",
  choosePaymentMethod: "Chọn phương thức thanh toán",
  chooseProductsCanBeDiscounted: "Chọn những mặt hàng trong kho có thể được giảm giá.",
  chooseRole: "Chọn vai trò cho nhân viên này",
  chooseTheLocationWhereThisProduct: "Chọn các vị trí bán mặt hàng này và nơi trừ nguyên liệu.",
  chooseVouchers: "Chọn voucher",
  cityStateCountry: "Thành phố, Tỉnh, Mã bưu chính",
  clear: "Xóa",
  clearAllFilters: "Xóa tất cả bộ lọc",
  clearDownloads: "Xóa danh sách tải xuống",
  clearedTags: "Thẻ đã xóa",
  clearedUnusedAndExpiredCredits: "Tín dụng đã xóa, chưa dùng và hết hạn",
  clearedUnusedAndExpiredCreditsMessage: "Dành cho tín dụng đã nạp nhưng bị xóa, không hoàn lại hoặc đã hết hạn.",
  clearedUnusedAndExpiredCreditsPlaceholder: "Thu nhập khác (hết hạn)",
  clearedUnusedExpiredCredit: "Thu nhập khác (hết hạn)",
  clickHere: "nhấn vào đây",
  clickHereToRetry: "Nhấn vào đây để thử lại.",
  close: "Đóng",
  closePreview: "Đóng xem trước",
  closeReceiptPreview: "Đóng xem trước hóa đơn",
  closeShift: "Đóng ca",
  closeShiftWarning: "Đảm bảo mọi giao dịch đã được đồng bộ trước khi buộc đóng ca, và chỉ dùng chức năng này khi không thể đóng ca trên ứng dụng.",
  cloudbeds: "Cloudbeds",
  code: "Mã",
  codeMustBeUnique: "Mã phải là duy nhất",
  coffeeBeans: "hạt cà phê",
  columns: "Cột",
  combineYourProducts: "Kết hợp các mặt hàng để bán theo bộ.",
  comingSoon: "Sắp ra mắt",
  communityGuidelines: "nguyên tắc cộng đồng",
  companyDetails: "Thông tin công ty",
  companyRegistrationNo: "Mã số đăng ký doanh nghiệp",
  completed: "Đã hoàn thành",
  completedBy: "Hoàn thành bởi",
  completedOn: "Hoàn thành lúc",
  completeStocktake: "Hoàn tất kiểm kho",
  completeStocktakeConfirmation: "Hoàn tất {0}?",
  completeSubscription: "Hoàn tất đăng ký gói",
  completeYourSubscription: "Hoàn tất đăng ký gói để truy cập địa điểm của bạn, ",
  composite: "Tổng hợp",
  composition: "Thành phần",
  compositionGuide: "Hướng dẫn thành phần",
  confirm: "Xác nhận",
  confirmationPending: "Đang chờ xác nhận",
  confirmed: "Đã xác nhận",
  confirmImport: "Xác nhận nhập",
  confirmImportDesc: "Bạn có chắc muốn nhập hàng tồn kho?",
  confirmPassword: "Xác nhận mật khẩu",
  confirmStockAdjustment: "Xác nhận điều chỉnh tồn kho",
  confirmTransfer: "Xác nhận chuyển kho",
  connect: "Kết nối",
  connectAndInstall: "Kết nối và cài đặt",
  nttDataPaymentGatewayEnquiry: "Yêu cầu thông tin cổng thanh toán NTT DATA",
  connected: "Đã kết nối",
  connectedSuccessfully: "Kết nối thành công",
  connectPurchasePlus: "Kết nối Purchase Plus với tài khoản SoCashless của bạn.",
  connectStatus: "Trạng thái kết nối",
  contactNumber: "Số điện thoại liên hệ",
  contactUs: "liên hệ với chúng tôi",
  contactUs2: "Liên hệ",
  continue: "Tiếp tục",
  continueAs: "Tiếp tục với tư cách {0}",
  continueBanningThisTag: "Tiếp tục chặn thẻ này?",
  continuingOnThisPageWillLogout: "Tiếp tục trên trang này sẽ đăng xuất phiên hiện tại của bạn.",
  copied: "Đã sao chép!",
  copiedCUEFnumber: "Đã sao chép số CUEF",
  copiedCUFEnumber: "Đã sao chép số CUFE",
  copy: "Sao chép",
  copyLink: "Sao chép liên kết",
  copyrightYear: "Bản quyền © 2026",
  copyTheApkDownloadUrl: "Sao chép URL tải APK ở trên hoặc quét mã QR bằng ứng dụng quét QR.",
  costOfGoodsSold: "Giá vốn hàng bán (COGS)",
  costOfGoodsSoldMessage: "Tài khoản mặc định cho giá vốn nguyên liệu khi được bán.",
  costOfGoodsSoldPlaceholder: "COGS/COGS",
  country: "Quốc gia",
  createAccessPoint: "Tạo điểm ra vào",
  createAccount: "Tạo tài khoản",
  createAccountCode: "Tạo mã tài khoản",
  createALocation: "Tạo vị trí",
  createAndManageProducts: "Tạo và quản lý mặt hàng có thể bán tại các vị trí của bạn",
  createAndManageRawMaterials: "Tạo và quản lý nguyên liệu thô và tồn kho cho từng vị trí.",
  createAndManagerDiscounts: "Tạo và quản lý chương trình giảm giá với các mặt hàng được giảm",
  createAndManagerVouchers: "Tạo và quản lý voucher dùng để đổi mặt hàng",
  createCategoriesToLink: "Tạo danh mục để liên kết và phân loại mặt hàng",
  createCategory: "Tạo danh mục",
  createDiscountPage: "Trang tạo giảm giá",
  createdSupplyItem: "Hàng tồn kho đã tạo",
  createLocation: "Tạo vị trí",
  createLocationToStoreYourProducts: "Tạo vị trí để lưu trữ mặt hàng của bạn.",
  createNewCategory: "Tạo danh mục mới",
  createNewCharge: "Tạo phụ phí mới",
  createNewDiscount: "Tạo giảm giá mới",
  createNewGuestProfile: "Tạo hồ sơ khách mới",
  createNewLocation: "Tạo vị trí mới",
  createNewProduct: "Tạo mặt hàng mới",
  createNewProductSet: "Tạo bộ mặt hàng mới",
  createNewProfile: "Tạo hồ sơ mới",
  createNewStaffProfile: "Tạo hồ sơ nhân viên mới",
  createNewStocktake: "Tạo phiếu kiểm kho mới",
  createNewSupplyItem: "Tạo hàng tồn kho mới",
  createNewVoucher: "Tạo voucher mới",
  createNote: "Tạo ghi chú",
  createPrinterProfile: "Tạo hồ sơ máy in",
  createProduct: "Tạo mặt hàng",
  createProductSet: "Tạo bộ mặt hàng",
  createStaffProfile: "Tạo hồ sơ nhân viên",
  createStaffWhoCan: "Tạo nhân viên có thể nạp tín dụng, đăng ký khách và bán hàng tại địa điểm của bạn.",
  createTheProduct: "Tạo các mặt hàng để bán tại địa điểm của bạn.",
  createVenue: "Tạo địa điểm",
  createVenuePage: "Trang tạo địa điểm",
  createVoucherPage: "Trang tạo voucher",
  createVouchersForGuest: "Tạo voucher cho khách và nhân viên sử dụng!",
  createYourOwnIntegration: "Tạo tích hợp riêng với SoCashlessCONNECT",
  createYourVenue: "Tạo địa điểm của bạn",
  credentialsAreInvalid: "Rất tiếc, một số thông tin không hợp lệ. Vui lòng nhập đúng dữ liệu và thử lại.",
  credit: "Tín dụng",
  creditAutomaticallyExpires: "Tín dụng tự động hết hạn sau khi check-out",
  creditBalance: "Số dư tín dụng",
  creditCard: "Thẻ tín dụng",
  creditDebit: "Tín dụng/Ghi nợ",
  creditDebitSales: "Doanh thu thẻ tín dụng/ghi nợ",
  creditLimits: "Hạn mức tín dụng",
  credits: "Tín dụng",
  creditsDescription: "Gán tín dụng miễn phí cho khách trong nhóm này và đặt hạn mức tín dụng trả sau.",
  creditSettings: "Cài đặt tín dụng",
  creditsExpiration: "Hết hạn tín dụng",
  creditsExpirationDescription: "Đặt tín dụng hết hạn khi khách check-out.",
  creditsExpirationOnCheckout: "Tín dụng hết hạn khi check-out",
  creditsKept: "Tín dụng được giữ lại",
  creditsKeptByGuests: "Tín dụng khách giữ lại",
  creditsLiabilityAccount: "Tài khoản nợ phải trả tín dụng",
  creditsLiabilityAccountMessage: "Tài khoản tạm giữ cho mọi tín dụng được nạp vào thẻ trước khi bán hàng.",
  creditsLiabilityAccountPlaceholder: "Nợ phải trả/Tín dụng",
  creditsNeverExpires: "Tín dụng không bao giờ hết hạn sau khi check-out.",
  creditsReceived: "Tín dụng nhận được",
  creditsReceivedFromVenues: "Tín dụng nhận từ địa điểm khác",
  creditsWouldNeverExpire: "Tín dụng sẽ không hết hạn khi khách vẫn đang check-in.",
  cufe: "CUFE",
  dashboardCreditsKept: "Tín dụng được giữ lại",
  dashboardCreditsReceived: "Tín dụng nhận được",
  currency: "Tiền tệ",
  currencyAndFormat: "Tiền tệ và định dạng",
  currentGuestProfiles: "Hồ sơ khách hiện tại",
  currentPassword: "Mật khẩu hiện tại",
  currentPasswordAndNewPasswordMatched: "Mật khẩu hiện tại và mật khẩu mới trùng nhau",
  currentQty: "SL hiện tại",
  custom: "Tùy chỉnh",
  customDateTime: "Khoảng ngày giờ tùy chỉnh",
  customerBehaviourOverTime: "Hành vi khách hàng theo thời gian",
  customFields: "Trường tùy chỉnh",
  customizeReceipt: "Tùy chỉnh từng phần của hóa đơn.",
  customizeSectionReceipt: "Tùy chỉnh các phần của hóa đơn.",
  customLabel: "Nhãn tùy chỉnh",
  customName: "Tên tùy chỉnh",
  customNameIsAlreadyExisting: "Tên tùy chỉnh đã tồn tại.",
  customQuestion: "Câu hỏi tùy chỉnh",
  customQuestions: "Câu hỏi tùy chỉnh",
  customTax: "Thuế tùy chỉnh",
  daily: "Hằng ngày",
  dashboard: "Trang tổng quan",
  home: "Trang chủ",
  dataError: "Lỗi dữ liệu",
  dataIncorrectly: "Dữ liệu không chính xác",
  date: "Ngày",
  dates: "Ngày",
  dateAndTime: "Ngày và giờ",
  dateAndTimeOfTransaction: "Ngày giờ giao dịch",
  dateBanned: "Ngày chặn",
  dateBlocked: "Ngày chặn",
  dateCreated: "Ngày tạo",
  dateIssuedWithColonSymbol: "Ngày phát hành:",
  dateModified: "Ngày sửa đổi",
  dateOfCheckin: "Ngày check-in",
  dateOfCheckout: "Ngày check-out",
  dateOfRegistration: "Ngày đăng ký",
  dateRange: "Khoảng ngày",
  day: "ngày",
  dayEnd: "Kết thúc ngày",
  days: "ngày",
  daysAfterCheckout: "ngày sau khi check-out",
  dayStart: "Bắt đầu ngày",
  daySummary: "Tổng kết ngày",
  debitCredit: "Thẻ ghi nợ / tín dụng",
  default: "Mặc định",
  defaultAccountForTaxes: "Tài khoản mặc định cho thuế tính trên mỗi mặt hàng.",
  defaultFields: "Trường mặc định",
  defaultInventoryGroup: "Nhóm kho mặc định",
  defaultMode: "Chế độ mặc định",
  defaultModeSettingDesc: "Theo mặc định, ứng dụng di động sẽ được đặt ở chế độ:",
  defaultQuestions: "Câu hỏi mặc định",
  defaultTableName: "Tên bàn mặc định",
  defaultTax: "Thuế mặc định",
  defectiveTag: "Thẻ lỗi",
  defectiveTags: "Thẻ lỗi",
  delete: "Xóa",
  deleteAccessPoint: "Xóa điểm ra vào",
  deleteAccessPointDesc: "Bạn có chắc muốn xóa điểm ra vào này? ",
  deleteAProduct: "Xóa mặt hàng",
  deleteAProduct2: "Xóa mặt hàng?",
  deleteAProductSet: "Xóa bộ mặt hàng",
  deleteCategories: "Xóa {0} danh mục",
  deleteCategory: "Xóa danh mục",
  deleteCharge: "Xóa phụ phí",
  deleteChargeFailed: "Không thể xóa phụ phí, vui lòng thử lại sau",
  deleteCurrentlyBeingUsed: "{0} đang được dùng trong một số bộ mặt hàng. Để tiếp tục, vui lòng xóa mặt hàng này khỏi các bộ mặt hàng sau",
  deleted: "Đã xóa",
  deleteDiscount: "Xóa giảm giá",
  deletedPaymentMethod: "Đã xóa phương thức thanh toán “{0}“.",
  deletedSuccessfully: "Xóa thành công",
  deletedTax: "Đã xóa thuế “{0}“.",
  deleteGuestProfile: "Xóa hồ sơ khách",
  deleteLocation: "Xóa vị trí",
  deleteLocationNote: "Lưu ý: Các giao dịch trước đây với vị trí này sẽ được giữ lại.",
  deleteName: "Xóa “{0}“?",
  deleteNote: "Xóa ghi chú",
  deletePaymentGateway: "Xóa cổng thanh toán",
  deletePaymentMethod: "Xóa phương thức thanh toán",
  deletePrinterProfile: "Xóa hồ sơ máy in",
  deleteProduct: "Xóa {0}?",
  deleteProducts: "Xóa {0} mặt hàng?",
  deleteProducts2: "Xóa {0} mặt hàng",
  deleteProductSet: "Xóa bộ mặt hàng?",
  deleteQuestion: "Xóa câu hỏi",
  deleteSelectedCategories: "Xóa các danh mục đã chọn",
  deleteSelectedCategory: "Xóa danh mục đã chọn",
  deleteSelectedProduct: "Xóa mặt hàng đã chọn",
  deleteSelectedProducts: "Xóa các mặt hàng đã chọn",
  deleteStaff: "Xóa nhân viên",
  deleteStaffModalDesc: "Bạn sắp xóa nhân viên. Những nhân viên này sẽ không còn quyền truy cập Venue. Hành động này không thể hoàn tác.",
  deleteStaffModalNote: "Lưu ý: Các giao dịch trước đây của những nhân viên này sẽ được giữ lại",
  deleteStaffProfile: "Xóa hồ sơ nhân viên",
  deleteStaffSuccessfully: "Xóa nhân viên thành công",
  deleteSupplyItem: "Xóa hàng tồn kho",
  deleteTax: "Xóa thuế",
  deleteThis: "Xóa {0} này?",
  deleteThisMultiple: "Xóa {0} {1}?",
  deleteThisQuestion: "Xóa câu hỏi này?",
  deleteVoucher: "Xóa voucher",
  deletingLoading: "Đang xóa...",
  deletingName: "Đang xóa {0}",
  deletingThisLocation: "Xóa vị trí này cũng sẽ xóa số dư tồn kho của mọi hàng tồn kho. Hành động này không thể hoàn tác.",
  denominations: "Mệnh giá",
  departure: "Khởi hành",
  departureDate: "Ngày đi",
  describeThisProduct: "Mô tả mặt hàng này...",
  describeThisProductSet: "Mô tả bộ mặt hàng này",
  description: "Mô tả",
  destinationLocation: "Vị trí đích",
  destinationLocationNewQty: "SL mới tại vị trí đích",
  device: "Thiết bị",
  deviceId: "ID thiết bị",
  deviceImei: "IMEI thiết bị",
  deviceImeiSerial: "IMEI / Số serial thiết bị",
  deviceInfo: "Thông tin thiết bị",
  deviceLimitExceeded: "Bạn đang dùng {0} thiết bị, vượt quá giới hạn {1} thiết bị của gói. Vui lòng liên hệ chủ địa điểm để nâng cấp gói.",
  deviceLimitExceededManager: "Bạn đang dùng {0} thiết bị, vượt quá giới hạn {1} thiết bị của gói. Vui lòng nâng cấp gói.",
  deviceList: "Danh sách thiết bị",
  deviceMac: "Địa chỉ MAC thiết bị",
  deviceMacAddress: "Địa chỉ MAC thiết bị",
  deviceName: "Tên thiết bị",
  deviceNameAlreadyExists: "Tên thiết bị này đã tồn tại",
  deviceNameUpdated: "Đã cập nhật thiết bị “{0}”.",
  devices: "Thiết bị",
  deviceSerialNumber: "Số serial thiết bị",
  deviceUid: "UID thiết bị",
  dianError: "Lỗi Dian",
  difference: "Chênh lệch",
  directory: "Danh bạ",
  disabled: "Đã tắt",
  disableSellingOnPos: "Tắt bán trên POS",
  discard: "Hủy bỏ",
  discardChanges: "Hủy thay đổi",
  discardWristbandKeepingSettings: "Hủy cài đặt giữ vòng đeo tay",
  disclaimer: "Tuyên bố miễn trừ",
  disclaimerCategoryReport: "LƯU Ý: Có thể có mặt hàng được gán nhiều danh mục, dẫn đến việc tính trùng ở mỗi dòng.",
  disclaimerDesc: "Xin lưu ý rằng việc sử dụng phiên bản cũ của ứng dụng không được khuyến nghị và có thể gây ra vấn đề hiệu năng hoặc lỗ hổng bảo mật. Để đảm bảo hiệu năng tối ưu và mức bảo mật cao nhất, chúng tôi đặc biệt khuyến nghị bạn cập nhật lên phiên bản mới nhất của ứng dụng sớm nhất có thể.\nCảm ơn sự thông cảm và hợp tác của bạn",
  disconnect: "Ngắt kết nối",
  discount: "Giảm giá",
  discountableProducts: "Mặt hàng được giảm giá",
  discountAmount: "Số tiền giảm",
  discountApplied: "Đã áp dụng giảm giá",
  discountCanBeApplied: "Giảm giá này có thể áp dụng tại địa điểm của bạn.",
  discountCreated: "Đã tạo giảm giá \"{0}\".",
  discountDeleted: "Đã xóa giảm giá \"{0}\".",
  discountName: "Tên giảm giá",
  discountWithNamePercentage: "{0} ({1} - {2}%)",
  itemDiscountLabel: "Giảm giá: {0}({1}%)",
  itemDiscountFixedLabel: "Giảm giá: {0}",
  itemDiscountAmountText: "{0} x (- {1})",
  discountNameAlreadyExist: "Tên giảm giá này đã tồn tại.",
  discountRateOrValue: "Tỷ lệ hoặc giá trị giảm",
  discountReport: "Báo cáo giảm giá",
  discounts: "Giảm giá",
  discountsPage: "Trang giảm giá",
  discountType: "Loại giảm giá",
  discountUpdated: "Đã cập nhật giảm giá \"{0}\".",
  discrepancy: "Chênh lệch",
  displayCategoryInPos: "Hiển thị danh mục này trên thiết bị POS.",
  displayedIn: "Hiển thị tại",
  displayName: "Tên người bán",
  distribution: "Phân bổ",
  done: "Xong",
  dontSellOnPos: "Không bán trên POS",
  dontWorry: "Đừng lo!",
  download: "Tải xuống",
  downloadAndSync: "Tải ứng dụng SoCashlessVENUE và đồng bộ giao dịch đầu tiên",
  downloadAPK: "Tải APK",
  downloading: "Đang tải xuống...",
  downloadTemplate: "Tải mẫu",
  dropdown: "Danh sách thả xuống",
  duplicateOption: "Tùy chọn bị trùng",
  easierGuestReg: "Đăng ký và check-in khách dễ dàng hơn",
  eatAppIdPlaceholder: "Nhập ID phòng Eat App",
  eatAppMapping: "Liên kết hồ sơ khách với Eat App",
  eatAppMappingDescription: "Nhập ID phòng Eat App để liên kết với hồ sơ khách này.",
  edit: "Sửa",
  editAccessPoint: "Sửa điểm ra vào",
  editAccessToken: "Sửa mã truy cập",
  editAccount: "Sửa tài khoản",
  editCategory: "Sửa danh mục",
  editCharge: "Sửa phụ phí",
  editDetails: "Sửa chi tiết",
  editDevice: "Sửa thiết bị",
  editDiscountsPage: "Trang sửa giảm giá",
  editGuestProfile: "Sửa hồ sơ khách",
  editLocation: "Sửa vị trí",
  editLocations: "Sửa vị trí",
  editNewCategory: "Sửa danh mục mới",
  editNote: "Sửa ghi chú",
  editPaymentGateway: "Sửa cổng thanh toán",
  editPaymentMethod: "Sửa phương thức thanh toán",
  editPaymentMethods: "Sửa phương thức thanh toán",
  editPrinter: "Sửa hồ sơ máy in",
  editProduct: "Sửa mặt hàng",
  editProductSet: "Sửa bộ mặt hàng",
  editQuestions: "Sửa câu hỏi",
  editSFTPDetails: "Sửa thông tin SFTP",
  editStaff: "Sửa nhân viên",
  editStaffPage: "Trang sửa nhân viên",
  editStaffProfilePage: "Trang sửa hồ sơ nhân viên",
  editSupplyItem: "Sửa hàng tồn kho",
  editTax: "Sửa thuế",
  editVariants: "Sửa biến thể",
  editVoucherPage: "Trang sửa voucher",
  editYourAccountPreferences: "Chỉnh sửa tùy chọn tài khoản, địa chỉ email và mật khẩu.",
  egAppliesToGuests: "VD: Áp dụng cho khách từ 60 tuổi trở lên",
  egSeniorDiscount: "VD: Giảm giá người cao tuổi",
  egSizeFlavor: "VD: Kích cỡ, Hương vị",
  eightCharactersMinimum: "Tối thiểu 8 ký tự",
  eInvoice: "Hóa đơn điện tử",
  eInvoiceSyncSuccessfully: "Hóa đơn điện tử đã được đồng bộ thành công",
  eitherYouHavePoorConnection: "Có thể kết nối mạng của bạn kém, quyền truy cập bị từ chối hoặc có lỗi xảy ra từ phía chúng tôi.",
  resetToAllDay: "Đặt lại thành cả ngày",
  returnCreditsOutlet: "Điểm bán hoàn trả tín dụng",
  revenueAccountAssigned: "Đã gán tài khoản doanh thu",
  saleOutlet: "Điểm bán",
  salesByPaymentType: "Doanh thu theo loại thanh toán",
  salesOutlet: "Điểm bán hàng",
  saturday: "Thứ Bảy",
  saveQuestions: "Lưu câu hỏi",
  searchGuestsByNameOrId: "Tìm khách theo tên hoặc ID thẻ",
  selectCreditsKeptOutlet: "Chọn điểm bán giữ tín dụng",
  selectCreditsReceivedOutlet: "Chọn điểm bán nhận tín dụng",
  selectedRefundType: "Chọn loại hoàn tiền",
  selectReturnCreditsOutlet: "Chọn điểm bán hoàn trả tín dụng",
  selectSalesOutlet: "Chọn điểm bán hàng",
  selectService: "Chọn dịch vụ",
  selectTimezone: "Chọn múi giờ",
  selectTopUpOutlet: "Chọn điểm nạp tiền",
  service: "Dịch vụ",
  serviceCharge: "Phí dịch vụ",
  setRevenueAccount: "Đặt tài khoản doanh thu",
  setTime: "Đặt giờ",
  sevenRoomsDescription: "Nền tảng trải nghiệm khách và đặt chỗ cho ngành dịch vụ - khách sạn.",
  shiftHasUnsyncedTransactions: "Ca này vẫn còn giao dịch chưa đồng bộ. Vui lòng kiểm tra thiết bị của ca này và vào màn hình \"Push Venue Data\" để đồng bộ.",
  showing: "Hiển thị:",
  siigoDescription: "Kế toán trực tuyến với hóa đơn tuân thủ DIAN cho Colombia.",
  snAbbr: "STT",
  software: "Phần mềm",
  spentOnSales: "Chi tiêu cho bán hàng",
  staffPaymentMethodTooltip: "Phương thức thanh toán được chấp nhận cho các vai trò Nạp tín dụng, Bán trên POS và Đăng ký khách.",
  sunday: "Chủ Nhật",
  table: "Bàn",
  tableManagementAndReservations: "Quản lý bàn và đặt chỗ",
  thisArticle: "Bài viết này",
  thursday: "Thứ Năm",
  ticketId: "ID vé",
  timeAccessed: "Thời gian truy cập",
  toLabel: "Đến",
  topUpOutlet: "Điểm nạp tiền",
  toppedUp: "Đã nạp",
  transactionsNotSynchronizingToMews: "Giao dịch không đồng bộ tới MEWS?",
  transferQuantityCannotExceedOriginal: "Số lượng chuyển không được vượt quá số lượng gốc",
  tuesday: "Thứ Ba",
  unableToLoadPage: "Không thể tải trang",
  pleaseCheckYourConnectionAndContactSupport: "Vui lòng kiểm tra kết nối và thử lại. Nếu sự cố vẫn tiếp diễn, vui lòng liên hệ support@socashless.com",
  email: "Email",
  emailAddress: "Địa chỉ email",
  emailAlreadyInVenue: "Email này đã được liên kết với một tài khoản tại địa điểm này.",
  emailDoesntHaveRecord: "Email bạn nhập không khớp với dữ liệu của chúng tôi, vui lòng kiểm tra lại và thử lại.",
  enableDifferentiateEntryExit: "Bật phân biệt Vào/Ra",
  enableSellingOnPos: "Bật bán trên POS",
  enableTip: "Bật tiền tip?",
  end: "Kết thúc",
  endDay: "Kết thúc ngày",
  endedBy: "Kết thúc bởi",
  endOfDay: "Chốt cuối ngày",
  endOfDayChecklist: "Danh sách kiểm tra chốt cuối ngày",
  endOfDayCompleted: "Đã hoàn tất chốt cuối ngày",
  endOfDayFailed: "Chốt cuối ngày thất bại",
  endOfDayReports: "Báo cáo chốt cuối ngày",
  dailyClose: "Chốt cuối ngày",
  endOfDayReportsListPage: "Trang danh sách báo cáo chốt cuối ngày",
  endOfDayRunning: "Đang chạy chốt cuối ngày. Vui lòng tải lại trang để cập nhật trạng thái Thời gian kết thúc của EOD.",
  enterEachOption: "Nhập từng tùy chọn, phân tách bằng dấu phẩy",
  enteredPasswordIncorrect: "Mật khẩu đã nhập không đúng.",
  enterEmailToLogin: "Nhập địa chỉ email để đăng nhập",
  enterYourEmailAddress: "Nhập địa chỉ email của bạn",
  enterYourPassword: "Nhập mật khẩu của bạn",
  equity: "Vốn chủ sở hữu",
  error: "Lỗi",
  errorLoadingColors: "Lỗi tải màu. Vui lòng thử lại sau.",
  eventMode: "Chế độ sự kiện",
  eWallet: "Ví điện tử",
  example1: "Ví dụ 1",
  example1AssembleProduct: "{0}: Một ly Cafe Latte cần {1}, {2} và {3}. Tồn kho hạt cà phê, sữa và đường sẽ được trừ khi một ly Cafe Latte được bán.",
  example2: "Ví dụ 2",
  example2AssembleProduct: "{0}: Rượu vang có thể bán theo {1} hoặc theo {2}. Chọn rượu vang làm hàng tồn kho, sau đó tạo các biến thể “chai” và “ly” và điều chỉnh số lượng cho từng biến thể, để tồn kho được trừ tương ứng từ cùng một hàng tồn kho.",
  expectedEndingBalance: "Số dư cuối dự kiến",
  expectedQty: "SL dự kiến",
  expense: "Chi phí",
  expired: "Đã hết hạn",
  export: "Xuất",
  exportCheckinDetails: "Xuất chi tiết check-in",
  exportGuestReport: "Xuất báo cáo khách",
  exportList: "Xuất danh sách",
  exportRegisterReport: "Xuất báo cáo ca",
  exportTaxReport: "Xuất báo cáo thuế",
  exportTransactions: "Xuất giao dịch",
  exportXlsx: "Xuất file XLSX",
  expStockQty: "SL tồn kho dự kiến",
  extendThePower: "Mở rộng sức mạnh của SoCashlessVENUE với các tiện ích bổ sung hàng đầu.",
  externalPaymentStatus: "Trạng thái thanh toán bên ngoài",
  externalPayment: "Thanh toán bên ngoài",
  extremelyHighDenominations: "Mệnh giá cực cao",
  failed: "Thất bại",
  failedToLoad: "Tải thất bại.",
  featureLocked: "Tính năng bị khóa",
  feedback: "Phản hồi",
  feelFreeToContactSocashless: "Đừng ngần ngại liên hệ với SoCashless.",
  female: "Nữ",
  fileImported: "Đã nhập tệp",
  filters: "Bộ lọc",
  findSimilar: "Tìm tương tự",
  firstName: "Tên",
  fixedAmount: "Số tiền cố định",
  fixedAmountRange: "Số tiền cố định phải trong khoảng 1-9.999.999",
  followTheOnScreenInstructionsToCompleteTheDownloadAndInstallation: "Làm theo hướng dẫn trên màn hình để hoàn tất tải xuống và cài đặt.",
  footerSection: "Phần chân trang",
  forApproval: "Chờ phê duyệt",
  forceBanned: "Chi tiết buộc check-out và chặn",
  forceCheckout: "Buộc check-out",
  forceCheckOutBy: "Buộc check-out bởi",
  forceCheckoutDetails: "Chi tiết buộc check-out",
  forceCheckoutName: "Buộc check-out {0}?",
  forcedCheckedOutBy: "Buộc check-out bởi",
  forDevicesWithoutTheGooglePlayStore: "Đối với thiết bị không có Google Play Store:",
  formatting: "Định dạng",
  forProperReportingAndTo: "Để báo cáo chính xác và giữ trang tổng quan luôn cập nhật, vui lòng chạy Chốt cuối ngày hằng ngày để tránh mất dữ liệu.",
  forProperReportingWithYourMews: "Để báo cáo chính xác với tài khoản MEWS, vui lòng đảm bảo accounting editable history window được đặt là 7 ngày. Chạy Chốt cuối ngày hằng ngày để tránh mất dữ liệu.",
  freeCredits: "Tín dụng miễn phí",
  freeCreditsAreCreditsThatAreFreeOfCharge: "Tín dụng miễn phí là tín dụng không mất phí. Những tín dụng này",
  freeCreditsHoverTooltip: "Tín dụng miễn phí không được hoàn lại và sẽ được ưu tiên sử dụng trước khi thanh toán.",
  freeCreditsIssued: "Tín dụng miễn phí đã cấp",
  freeCreditsKept: "Tín dụng miễn phí được giữ lại",
  freeCreditsLiabilityAccount: "Tài khoản nợ phải trả tín dụng miễn phí",
  freeCreditsLiabilityAccountMessage: "Chi phí tín dụng miễn phí đã cấp cho khách khi được sử dụng.",
  freeCreditsLiabilityAccountPlaceholder: "Nợ phải trả/Tín dụng miễn phí",
  freeCreditsReceived: "Tín dụng miễn phí nhận được",
  freeCreditsRemoved: "Tín dụng miễn phí đã xóa",
  freeCreditsReport: "Báo cáo tín dụng miễn phí",
  freeTrial: "Dùng thử miễn phí 30 ngày!",
  from: "Từ",
  frontOffice: "Lễ tân",
  frontOfficeRoleAppDesc: "Vai trò này không có quyền liên quan đến ứng dụng và sẽ không thể đăng nhập trên thiết bị.",
  frontOfficeRoleDashboardDesc: "Cho phép truy cập Thống kê, Đặt chỗ, Khách, Giao dịch, Báo cáo, Thiết bị và Chặn thẻ trên trang quản trị",
  fullPay: "Thanh toán toàn bộ",
  full: "Đầy đủ",
  future: "Tương lai",
  gender: "Giới tính",
  general: "Chung",
  generalSettings: "Cài đặt chung",
  generateAndDownload: "Tạo & tải xuống",
  generateQRCode: "Tạo mã QR",
  generateQRDescription: "Tạo và in mã QR để khách quét và đặt món từ thực đơn trực tuyến của vị trí này.",
  generatingReport: "Đang tạo báo cáo...",
  getFreeCredit: "Nhận tín dụng miễn phí",
  getNotifications: "Nhận thông báo",
  getSocashlessVENUEeBook: "Nhận eBook SoCashlessVENUE",
  getStarted: "Bắt đầu",
  glass: "ly",
  glossary: "Thuật ngữ",
  goToThe: "Đi tới ",
  goToTheSiigoApiKey: "trên trang quản trị Siigo để tìm API Key của bạn.",
  goToVenueTabAndTapOnPushVenueData: "Vào tab “Venue” và nhấn Push Venue Data",
  goToXDashboard: "Đi tới trang quản trị {0}",
  grossProfit: "Lợi nhuận gộp",
  guest: "Khách",
  guestCheckedOutAndBanned: "Khách đã check-out và thẻ đã bị chặn.",
  guestDetails: "Thông tin khách",
  guestId: "ID khách",
  guestInfoNotYetSync: "Thông tin khách chưa được đồng bộ",
  guestInformationYouCollect: "Thông tin khách bạn thu thập khi check-in.",
  guestList: "Danh sách khách",
  guestName: "Tên khách",
  guestNameAndOrTagId: "Tên khách và/hoặc ID thẻ",
  guestOrTagStatus: "Trạng thái khách hoặc thẻ",
  guestProfile: "Hồ sơ khách",
  guestProfileAmountPlaceholder: "0.00",
  guestProfileDeleted: "Đã xóa hồ sơ khách.",
  guestProfileDescriptionPlaceholder: "VD: “Khách check-in tại khu ẩm thực“",
  guestProfileList: "Danh sách hồ sơ khách",
  guestProfileName: "Tên hồ sơ khách",
  guestProfileNameCreate: "Đã tạo hồ sơ khách “{0}”.",
  guestProfileNamePlaceholder: "VD: “Khách khu ẩm thực“",
  guestProfiles: "Hồ sơ khách",
  guestQuestions: "Câu hỏi cho khách",
  guests: "Khách",
  guestsCheckedIn: "Khách đã check-in",
  guestSince: "Là khách từ {0}",
  guestsNewBalance: "Số dư mới của khách",
  guestSpecialRequest: "Yêu cầu đặc biệt của khách",
  guestsPreviousBalance: "Số dư trước của khách",
  guestsPreviousBalanceTotalPaidAndNewBalance: "Số dư trước, tổng đã thanh toán và số dư mới của khách",
  guestsStatus: "Trạng thái khách",
  guestTap: "Lượt quẹt của khách",
  guestWithColonSymbol: "Khách:",
  guidelineDownloadOrUpdateApp: "Hướng dẫn tải xuống hoặc cập nhật ứng dụng",
  headerSection: "Phần đầu trang",
  headOfBooking: "Người đứng tên đặt chỗ",
  headOfReservation: "Người đứng tên đặt chỗ",
  hello: "Xin chào",
  helpCenter: "Trung tâm trợ giúp",
  here: "tại đây",
  hidden: "Đã ẩn",
  hide: "Ẩn",
  hideDetails: "Ẩn chi tiết",
  hideInPos: "Ẩn trên POS",
  hideOnlineMenu: "Ẩn trên thực đơn trực tuyến",
  hideVariant: "Ẩn biến thể",
  highDenominations: "Mệnh giá cao",
  hiHeresWhatsHappening: "Chào {0}, chào mừng đến với trang tổng quan.",
  hiName: "Chào, {0}",
  goodMorning: "Chào buổi sáng, {0}",
  goodAfternoon: "Chào buổi chiều, {0}",
  goodEvening: "Chào buổi tối, {0}",
  heresHowVenueIsPerforming: "Đây là tình hình hoạt động của {0}.",
  holdingAccountForToppedUpItems: "Tài khoản tạm giữ cho mọi tín dụng được nạp vào thẻ trước khi bán hàng",
  hostname: "Tên máy chủ",
  hour: "giờ",
  hourly: "Theo giờ",
  hours: "giờ",
  id: "ID",
  idType: "Loại giấy tờ",
  ifYoudLikeToJustStopSellingProduct: "Nếu bạn chỉ muốn ngừng bán một mặt hàng trên POS, chỉ cần tắt tùy chọn “Bán trên POS”.",
  ifYouHaveAPreviousVersionOfApp: "Nếu bạn có phiên bản ứng dụng cũ, vui lòng xóa ứng dụng trước khi cập nhật",
  ifYouLeaveThisPage: "Nếu rời trang này, mọi thay đổi chưa lưu sẽ bị mất. Bạn có chắc muốn hủy thay đổi?",
  ignore: "Bỏ qua",
  ignoreAllOpenShifts: "Bỏ qua tất cả ca đang mở",
  ignoreAllShifts: "Bỏ qua tất cả ca",
  ignoredShiftFromPrevious: "Ca bị bỏ qua từ EOD trước",
  imageTypeSize: "JPG, GIF hoặc PNG. Kích thước tối đa 1MB",
  impItem: "Nhập mặt hàng",
  impItemMaxSize: "Kích thước tối đa 25MB",
  impItemModalNote1: "Với Hàng tồn kho/Mặt hàng đã có trong kho, việc nhập sẽ tăng số lượng của hàng đó trong kho",
  impItemModalNote2: "Với Hàng tồn kho/Mặt hàng chưa có trong kho, nhấn xác nhận sẽ tạo SKU mới trong kho",
  impItemsErr1: "Không tìm thấy vị trí {0}",
  impItemsErr2: "Không tìm thấy đơn vị đo {0}",
  impItemsErr3: "Dữ liệu sheet {0} {1} sai định dạng",
  impItemsErr4: "Có chênh lệch giá cho hàng tồn kho {0} + Đơn vị đo {1}",
  impItemsErr5: "Sheet {0} không được vượt quá 200 dòng",
  impItemsErr6: "Không tìm thấy danh mục",
  impItemsErr7: "Có chênh lệch giá cho Mặt hàng {0} + Đơn vị đo {1}",
  impItemsPlsRecheck: "Vui lòng kiểm tra lại dữ liệu trong tệp nhập và tải lên lại",
  import: "Nhập",
  importSupplyItems: "Nhập hàng tồn kho",
  importSupplyItemsCreateWholeProducts: "Nhập hàng tồn kho và tạo mặt hàng hoàn chỉnh",
  importSupplyItemsErr: "Tên vị trí không khớp với các vị trí hiện có tại địa điểm. Vui lòng kiểm tra lại",
  in: "trong",
  inactive: "Không hoạt động",
  include: "Bao gồm",
  indeterminate: "không xác định",
  information: "Thông tin",
  informationToCollect: "Thông tin cần thu thập khi đăng ký khách.",
  inHouse: "Đang lưu trú",
  inProgress: "Đang thực hiện",
  inputReason: "Nhập lý do",
  installAPK: "Cài đặt APK",
  inStock: "Còn hàng",
  integrateDesc: "Tích hợp với các hệ thống quản lý cơ sở lưu trú mạnh mẽ và nhiều hơn nữa.",
  integration: "Tích hợp",
  integrations: "Tích hợp",
  integrationSettingDesc: "Kết nối với các ứng dụng kinh doanh và năng suất khác để phát triển và tinh gọn hoạt động kinh doanh.",
  integrationSettings: "Cài đặt tích hợp",
  interval: "Khoảng thời gian",
  invalidFileType: "Loại tệp không hợp lệ. Chỉ chấp nhận JPG hoặc PNG.",
  invalidOptions: "Tùy chọn không hợp lệ.",
  invalidTimeRange: "Khoảng thời gian không hợp lệ",
  invalidToken: "Mã không hợp lệ",
  inventory: "Kho hàng",
  inventoryAccount: "Tài khoản hàng tồn kho",
  inventoryAccountMessage: "Dành cho hàng tồn kho đã mua và hàng trong kho trước khi bán.",
  inventoryAccountPlaceholder: "Tài sản/Hàng tồn kho",
  inventoryExisted: "Hàng tồn kho đã tồn tại",
  inventoryGainLossAccount: "Tài khoản lãi/lỗ hàng tồn kho",
  inventoryGainLossAccountMessage: "Dành cho chênh lệch khi kiểm kho, điều chỉnh tồn kho, v.v.",
  inventoryGainLossAccountPlaceholder: "Lãi/Lỗ từ bán hàng tồn kho",
  inventoryGroup: "Nhóm kho hàng",
  inventoryManagement: "Quản lý kho hàng",
  inventoryMovement: "Biến động kho",
  inventoryMovementPage: "Trang biến động kho",
  inventoryReport: "Báo cáo kho hàng",
  inventoryValue: "Giá trị tồn kho",
  invitationHasBeenSentTo: "Đã gửi lời mời tới {0}.",
  inviteNewStaff: "Mời nhân viên mới",
  inviteResponse: "Phản hồi lời mời",
  inviteYourStaff: "Mời nhân viên",
  inviteYourVenueStaff: "Mời nhân viên của địa điểm, quản lý vai trò và quyền truy cập của họ trên POS",
  invoice: "Hóa đơn",
  invoiced: "Đã xuất hóa đơn",
  invoiceDate: "Ngày hóa đơn",
  invoicedInSiigo: "Đã xuất hóa đơn trên Siigo",
  invoiceNumber: "Số hóa đơn",
  invoices: "Hóa đơn",
  invoiceType: "Loại hóa đơn",
  isAreserveWord: "là từ khóa dành riêng.",
  isDefault: "Là mặc định",
  isDefaultPaymentGateway: "Cổng thanh toán mặc định",
  issuanceLimit: "Giới hạn phát hành",
  issue: "Phát hành",
  issueDate: "Ngày phát hành",
  issuedBy: "Phát hành bởi",
  issuedOn: "Phát hành lúc",
  issueFreeCredits: "Cấp tín dụng miễn phí",
  item: "Mặt hàng",
  itemBargain: "Giá của mặt hàng này đã được thay đổi từ {0} thành {1}",
  itemImport: "Nhập mặt hàng",
  itemName: "Tên mặt hàng",
  items: "Mặt hàng",
  itemsSold: "Mặt hàng đã bán",
  itemTax: "Thuế mặt hàng",
  justNow: "Vừa xong",
  lastIssuedTo: "Phát hành gần nhất cho",
  lastModifiedBy: "Sửa lần cuối bởi",
  lastModifiedOn: "Sửa lần cuối lúc",
  lastName: "Họ",
  lastPurchasedProduct: "Mặt hàng mua gần nhất",
  lastSync: "Đồng bộ lần cuối",
  lastSynced: "Đồng bộ lần cuối {0}",
  lastVisitedLocation: "Vị trí ghé thăm gần nhất",
  learnHowToRenewSubscription: "Tìm hiểu cách gia hạn gói đăng ký",
  learnMore: "Tìm hiểu thêm",
  legalBusinessName: "Tên pháp lý của doanh nghiệp",
  letsGetStarted: "Hãy bắt đầu",
  liability: "Nợ phải trả",
  limit: "Giới hạn",
  limitVoucherPerPerson: "Giới hạn số voucher phát hành mỗi người",
  linkAccountingItem: "Liên kết khoản mục kế toán",
  linkMiniWeb: "Liên kết Mini Web",
  linkOutlet: "Liên kết vị trí",
  linkOutletHoverTooltip: "Liên kết với vị trí MEWS",
  linkWithMewsAccountingItems: "Liên kết với khoản mục kế toán MEWS",
  litePlanMaxProductReached: "Bạn đã đạt số lượng tối đa {0} mặt hàng của gói {1}.",
  litePlanMaxStaffReached: "Bạn đã đạt số lượng tối đa {0} nhân viên của gói {1}.",
  loading: "Đang tải...",
  locateAPK: "Tìm tệp APK",
  locateAPKDesc: "Mở trình quản lý tệp trên thiết bị và tìm tệp APK trong thư mục \"Downloads\".",
  location: "Vị trí",
  locationDesignation: "Vị trí làm việc",
  locationName: "Tên vị trí",
  locationNameAlreadyExist: "Vị trí này đã tồn tại. Vui lòng chọn tên khác.",
  locationNameCreated: "Đã tạo vị trí “{0}”.",
  locationNameDeleted: "Đã xóa vị trí “{0}”.",
  locationNameUpdated: "Đã cập nhật vị trí “{0}”.",
  locationQRCode: "Mã QR vị trí (một mã cho toàn bộ vị trí)",
  locations: "Vị trí",
  locationsList: "Danh sách vị trí",
  locationVoucherRedeemed: "Chọn vị trí có thể sử dụng voucher này.",
  logIn: "Đăng nhập",
  login: "Đăng nhập",
  loginHasEnded: "Phiên đăng nhập của bạn đã kết thúc. Vui lòng đăng nhập lại.",
  loginSessionEnded: "Phiên đăng nhập đã kết thúc",
  logout: "Đăng xuất",
  looksLikeAlreadyInSystem: "Có vẻ như bạn đã có trong hệ thống của chúng tôi!",
  looksLikeYouEncounteredSomething: "Có vẻ bạn đã gặp lỗi, chúng tôi tự động ghi nhận các lỗi này. Trong lúc chờ, hãy thử tải lại trang.",
  looksLikeYouHaveNoLocationYet: "Có vẻ bạn chưa có vị trí nào.",
  lostTag: "Thẻ bị mất",
  lostTags: "Thẻ bị mất",
  lowDenominations: "Mệnh giá thấp",
  lowerCaseNoneRefundable: "không hoàn lại",
  lowerCaseTopUpCredits: "tín dụng nạp",
  lowOrOutOfStock: "Sắp hết hoặc hết hàng",
  lowParLevel: "Mức tồn tối thiểu thấp",
  mailingList: "Danh sách nhận email",
  male: "Nam",
  mainGuestTag: "Chính",
  manageAccountNotificationStockLevel: "Quản lý tài khoản nhận thông báo khi mặt hàng giảm xuống mức cảnh báo.",
  manageAndAssignQuestions: "Quản lý và gán câu hỏi check-in, tín dụng miễn phí và voucher cho các hồ sơ khách khác nhau.",
  manageBusinessInfo: "Quản lý thông tin doanh nghiệp",
  manageEmailNotif: "Quản lý thông báo email gửi tới bạn và nhân viên.",
  manageHowVenueTax: "Quản lý cách địa điểm tính thuế tùy theo khu vực. Hãy tham khảo chuyên gia thuế để hiểu nghĩa vụ thuế của bạn.",
  manageImportantDetailsSettings: "Quản lý các thông tin và quy tắc quan trọng của địa điểm như cài đặt địa điểm, cài đặt thanh toán và tín dụng, cài đặt check-in và cài đặt tài khoản.",
  manageInventory: "Quản lý kho hàng",
  manageInventoryAndProducts: "Quản lý kho hàng và các mặt hàng của bộ này.",
  manageInventoryAndSupply: "Quản lý kho hàng và hàng tồn kho của mặt hàng này.",
  manageLocationTable: "Quản lý bàn và sắp xếp chỗ ngồi của vị trí này.",
  manageNotifcations: "Quản lý cảnh báo email và thông báo gửi tới nhân viên.",
  manageOfPermissionToEnterSpecificAreas: "Quản lý quyền vào các khu vực cụ thể",
  managePlacesYouStock: "Quản lý nơi bạn lưu kho và bán mặt hàng.",
  manager: "Quản lý",
  managerAuthorization: "Quản lý phê duyệt",
  manageReceipts: "Quản lý giao diện và thông tin trên hóa đơn.",
  managerRoleDesc: "Toàn quyền truy cập cả trang web và ứng dụng.",
  manageSupplyItems: "Quản lý hàng tồn kho",
  manageThePosDevicesVenue: "Quản lý các thiết bị POS đã đăng nhập và đang được sử dụng tại địa điểm",
  manageTheStocksPerLocation: "Quản lý tồn kho theo từng vị trí của hàng tồn kho này.",
  manageTipDesc: "Bật tiền tip và đặt tỷ lệ phần trăm tip muốn hiển thị trên POS",
  manageToppedUpCredits: "Quản lý tín dụng đã nạp, tín dụng miễn phí, tín dụng trả sau và tín dụng hết hạn.",
  manageVariants: "Quản lý biến thể",
  manageVenues: "Quản lý địa điểm",
  manageYourAccountsSales: "Quản lý tài khoản liên quan đến doanh thu, giá vốn, thuế mặt hàng hoặc giảm giá.",
  manageYourStaffProfileDescription: "Quản lý nhân viên, vai trò, vị trí làm việc và hồ sơ nhân viên mà họ thuộc về.",
  manageYourVenueSetting: "Quản lý cài đặt địa điểm như thuế và tiền tệ.",
  manageYourVenueSubscription: "Quản lý gói đăng ký, thông tin thanh toán và hóa đơn của địa điểm.",
  manageYourVenueTax: "Thêm và quản lý cách địa điểm tính thuế.",
  manuallyDownloadUpdateSocashlessApp: "Tải xuống/Cập nhật thủ công ứng dụng SoCashless từ Google Play Store:",
  mapAndManageAccounts: "Liên kết và quản lý tài khoản mặc định cho từng quy trình nghiệp vụ của SoCashlessVENUE.",
  mapAndManageAccountsLink: "Liên kết và quản lý tài khoản trong {0} để hạch toán chính xác",
  mapToSiigo: "Liên kết với Siigo",
  mapYourAccounts: "Liên kết tài khoản cho tài sản hàng tồn kho, chi phí chênh lệch, v.v.",
  margin: "Biên lợi nhuận",
  markUp: "Tỷ lệ lãi",
  maximumLengthCharacters: "Tối đa {0} ký tự.",
  maximumValueAllowed: "Giá trị tối đa cho phép là 20.000.000",
  maximumValueIs: "Giá trị tối đa là",
  maxProductReached: "Đã đạt số mặt hàng tối đa",
  maxStaffReached: "Đã đạt số nhân viên tối đa",
  measurement: "Đơn vị đo",
  measurements: "Đơn vị đo",
  mediumDenominations: "Mệnh giá trung bình",
  menuEngineering: "Phân tích thực đơn",
  merchantId: "Mã người bán",
  merchantSecret: "Khóa bí mật",
  merchantUrl: "URL người bán",
  mews: "MEWS",
  mewsAccounting: "MEWS_Accounting",
  mewsAccounting1: "Kế toán MEWS",
  mewsBookings: "MEWS_Bookings",
  mewsBookings1: "Đặt chỗ MEWS",
  mewsSystems: "MEWS Systems",
  mewsTaxCode: "Mã thuế có phải từ MEWS không?",
  mewsTaxCodeEditNote: "Lưu ý: Khi giao dịch được đồng bộ, các mặt hàng liên kết với thuế này sẽ có số tiền VAT trong MEWS.",
  milk: "sữa",
  minimum: "Tối thiểu",
  minimumCharactersAllowed: "Tối thiểu {0} ký tự",
  minimumOf: "Cần tối thiểu 2 mặt hàng.",
  minimumValueIs: "Giá trị tối thiểu là",
  minOfNCharacters: "Tối thiểu {0} ký tự",
  minute: "phút",
  minutes: "phút",
  missedCheckIn: "Bỏ lỡ check-in",
  missedCheckOut: "Bỏ lỡ check-out",
  missingTransactionsDetected: "Phát hiện giao dịch bị thiếu",
  mixed: "Hỗn hợp",
  mobileNumber: "Số điện thoại di động",
  mode: "Chế độ",
  month: "tháng",
  monthly: "Hằng tháng",
  months: "tháng",
  monthsAfterCheckout: "tháng sau khi check-out",
  mostPurchasedProduct: "Mặt hàng mua nhiều nhất",
  mostVisitedLocation: "Vị trí ghé thăm nhiều nhất",
  movement: "Biến động",
  multiProperty: "Nhiều cơ sở",
  na: "Không có",
  name: "Tên",
  nameAdded: "Đã thêm “{0}”.",
  nameYourProduct: "Đặt tên mặt hàng...",
  nameYourProductSet: "Đặt tên bộ mặt hàng...",
  nameYourSupplyItem: "Đặt tên hàng tồn kho",
  nationality: "Quốc tịch",
  needAdditionalSupportContact: "Nếu cần hỗ trợ thêm, vui lòng liên hệ {0}.",
  needHelp: "Cần trợ giúp?",
  netWeightN: "Khối lượng tịnh {0}",
  netValue: "Giá trị ròng",
  netValueFootnote: "(*) Giá trị ròng = Tạm tính + Phí dịch vụ − Voucher − Giảm giá.",
  new: "Mới",
  newBalance: "Số dư mới",
  newGuests: "Khách mới",
  newInviteLink: "Đã gửi liên kết mời mới tới \"{0}\".",
  newPassWord: "Mật khẩu mới",
  newProduct: "Mặt hàng mới",
  newProductSet: "Bộ mặt hàng mới",
  newQty: "SL mới",
  newQuantity: "Số lượng mới",
  newSku: "SKU mới",
  newToSocashless: "Mới sử dụng SoCashless?",
  nfcStatus: "Trạng thái NFC",
  nfcTags: "thẻ NFC",
  night: "đêm",
  no: "Không",
  noAccountsAvailable: "Không có tài khoản nào",
  noAccountsYet: "Chưa có tài khoản",
  noAvailableAccessPoint: "Không có điểm ra vào nào",
  noAvailableCategories: "Không có danh mục nào",
  noAvailableGuestProfile: "Không có hồ sơ khách nào",
  noAvailableLocations: "Không có vị trí nào",
  noAvailableLocationsYet: "Chưa có vị trí nào.",
  noAvailablePaymentMethodYet: "Chưa có phương thức thanh toán nào.",
  noAvailableStaff: "Không có nhân viên nào",
  noBannedTagsYet: "Chưa có thẻ bị chặn.",
  noBookingsYet: "Chưa có đặt chỗ.",
  noCheckInsInDateRange: "Không có lượt check-in nào trong khoảng ngày này.",
  noData: "Không có dữ liệu",
  noDashboardAccess: "Bạn hiện không có quyền truy cập trang quản trị.",
  noDataAvailable: "Không có dữ liệu",
  noDeviceAvailable: "Không có thiết bị nào",
  noDevicesFound: "Không tìm thấy thiết bị",
  noEndDate: "Không có ngày kết thúc",
  noLocation: "Không có vị trí",
  noLocationAvailable: "Không có vị trí nào",
  none: "Không có",
  noNotesFound: "Không tìm thấy ghi chú",
  nonRefundable: "Không hoàn lại",
  noOfCheckedIn: "{0} đã check-in",
  noOfCheckedOut: "{0} đã check-out",
  noOfGuests: "Số khách",
  noOfNights: "Số đêm",
  noOfTables: "Số bàn",
  noProductsAvailable: "Không có mặt hàng nào",
  noProductsSelected: "Chưa chọn mặt hàng nào.",
  nOptions: "{0} tùy chọn",
  noRecords: "Không có bản ghi.",
  noRecordsOf: "Không có bản ghi về",
  noRemainingBalance: "Không còn số dư",
  noReportsFound: "Không tìm thấy báo cáo.",
  noResultInSearch: "Không tìm thấy kết quả nào cho tìm kiếm của bạn.",
  noResults: "Không có kết quả",
  noResultsFound: "Không tìm thấy kết quả",
  noResultsMatching: "Không có kết quả khớp với",
  noResultsMatchingX: "Không có kết quả khớp với “{0}”",
  noReturnCreditsInDateRange: "Không có lượt hoàn trả tín dụng nào trong khoảng ngày này.",
  noSalesInDateRange: "Không có doanh thu nào trong khoảng ngày này.",
  noSearchFound: "Không tìm thấy",
  noSearchResultsForName: "Không có kết quả tìm kiếm cho {0}.",
  noShow: "Không đến",
  noStocks: "Hết hàng",
  noTagsFound: "Không tìm thấy thẻ.",
  noTagUid: "Không có UID thẻ",
  noTagYet: "Chưa có thẻ",
  notCheckedIn: "Chưa check-in",
  note: "ghi chú",
  notedByOn: "Ghi chú bởi {0} lúc {1}",
  notePreviousTransaction: "Lưu ý: Các giao dịch trước đây với những mặt hàng này sẽ được giữ lại.",
  notes: "Ghi chú",
  notesAndGuideline: "Ghi chú và hướng dẫn",
  noteTransactionStaff: "Lưu ý: Các giao dịch trước đây của nhân viên này sẽ được giữ lại.",
  noteUpdateLastVersion: "Lưu ý: Cửa sổ này sẽ tiếp tục hiển thị cho đến khi tất cả thiết bị đang hoạt động được cập nhật lên phiên bản mới nhất. Kiểm tra phiên bản ứng dụng trên thiết bị của bạn, ",
  notifications: "Thông báo",
  notificationSettings: "Cài đặt thông báo",
  notSellingOnPos: "Không bán trên POS",
  noVoucherAvailable: "Không có voucher nào",
  noVoucherMovement: "Không có biến động voucher.",
  noVouchersSelectedYet: "Chưa chọn voucher nào.",
  nowToDo: "ngay để thực hiện ",
  nthGuestWhoUseThisTag: "{0} khách đã dùng thẻ này.",
  nthStaffWhoUsedThisTag: "{0} nhân viên đã dùng thẻ này.",
  nthUse: "Lần dùng thứ {0}",
  nTon: "{0} đến {1}",
  numberOfGuests: "Số khách",
  numberOfNights: "Số đêm",
  offline: "Ngoại tuyến.",
  ok: "OK",
  okay: "Đồng ý",
  oldGuestId: "ID khách cũ",
  onboardingDescription: "Thiết lập địa điểm với các bước đơn giản sau để bắt đầu.",
  onboardingDescriptionCompleted: "Tuyệt vời! Bạn có thể bắt đầu bán hàng trên thiết bị POS SoCashlessVENUE! Đặt mua thẻ NFC ngay để thực hiện giao dịch không tiền mặt kèm mở khóa cửa! Hãy xem thêm ebook của chúng tôi về cách tối ưu địa điểm của bạn!",
  onboardingTitle: "Chào mừng! Hãy bắt đầu thiết lập địa điểm của bạn.",
  onboardingTitleCompleted: "Địa điểm của bạn đã sẵn sàng!",
  onceYouBanATag: "Khi bạn chặn một thẻ, thẻ đó không thể dùng để giao dịch tại địa điểm của bạn.",
  onceYouBlockATag: "Khi bạn chặn một thẻ, thẻ đó không thể dùng để giao dịch tại địa điểm của bạn.",
  onceYouCompleteStocktake: "Khi hoàn tất kiểm kho, số lượng thực tế của mọi hàng tồn kho sẽ được điều chỉnh tương ứng. Hành động này không thể hoàn tác.",
  onceYoureOnTheAppsPage: "Khi bạn đã ở trang của ứng dụng:",
  onceYoureOnTheAppsPageDesc: "Nhấn nút “Cài đặt”/“Cập nhật”\n(Khi cập nhật ứng dụng, Google Play Store sẽ tự động kiểm tra bản cập nhật và nhắc bạn cập nhật nếu cần.)",
  onlineMenuOnly: "Chỉ thực đơn trực tuyến",
  onlyDateRangesLessThanOneYear: "Chỉ chấp nhận khoảng ngày dưới một năm",
  onPos: "Trên POS",
  open: "Mở",
  opened: "Đã mở",
  openingBalance: "Số dư đầu ca",
  openReceiptPreview: "Mở xem trước hóa đơn",
  openWindow: "Mở cửa sổ tới vị trí",
  optionNameAlreadyExists: "Tên tùy chọn đã tồn tại",
  options: "Tùy chọn",
  orderQty: "SL đặt",
  orderQuantityRequired: "Bắt buộc nhập số lượng đặt",
  orderYour: "Đặt mua",
  orderYourNFCTags: "Đặt mua thẻ NFC",
  original: "Gốc",
  orNo: "Số OR#",
  other: "Khác",
  others: "Khác",
  outlet: "Vị trí",
  overview: "Tổng quan",
  pairedTagOnCheckin: "Thẻ đã ghép khi check-in",
  pairedTags: "Thẻ đã ghép",
  parLevel: "Mức tồn tối thiểu",
  password: "Mật khẩu",
  passwordDoesNotMatch: "Mật khẩu bạn nhập không khớp",
  passwordIncorrect: "Mật khẩu bạn nhập không đúng.",
  passwordsDoNotMatch: "Mật khẩu không khớp",
  pasteUrlInDeviceBrowserAndDownload: "Dán URL vào trình duyệt trên thiết bị và tải APK, hoặc mở liên kết từ mã QR để tải APK.",
  paymentAndCreditSettings: "Cài đặt thanh toán và tín dụng",
  paymentGatewayDeleted: "Đã xóa cổng thanh toán \"{0}\".",
  paymentGatewayName: "Tên cổng thanh toán",
  paymentGatewayUpdated: "Đã cập nhật cổng thanh toán \"{0}\".",
  paymentMethod: "Phương thức thanh toán",
  paymentMethodAddedName: "Đã thêm phương thức thanh toán “{0}“.",
  paymentMethodAlreadyExist: "Phương thức thanh toán đã tồn tại",
  paymentMethodInSiigo: "Phương thức thanh toán trên Siigo",
  paymentMethodName: "Tên phương thức thanh toán",
  paymentMethods: "Phương thức thanh toán",
  paymentMethodsDescription: "Tạo và quản lý các phương thức thanh toán bạn chấp nhận tại địa điểm.",
  paymentMethodsSettings: "Cài đặt phương thức thanh toán",
  paymentMethodsYouAccept: "Các phương thức thanh toán bạn chấp nhận tại địa điểm.",
  paymentOrder: "Lệnh thanh toán",
  paymentDetails: "Chi tiết thanh toán",
  totalBillToPay: "Tổng hóa đơn cần thanh toán",
  numberOfSplitPayments: "Số lần chia thanh toán",
  totalCollected: "Tổng đã thu",
  clickRowToExpand: "Nhấn vào một dòng để mở rộng",
  paymentDetailsOrder: "Đơn hàng",
  paidAmount: "Số tiền đã trả",
  fromCredit: "Từ tín dụng",
  fromFreeCredit: "Từ tín dụng miễn phí",
  byVoucher: "Bằng voucher",
  addFreeCredit: "Thêm tín dụng miễn phí",
  voucherUsed: "Voucher đã dùng",
  tapNumber: "Lượt quẹt #{0}",
  paidByAppliedVoucher: "Thanh toán bằng voucher đã áp dụng",
  returnFreeCreditByAppliedVoucher: "Hoàn tín dụng miễn phí từ voucher đã áp dụng",
  postpaidCreditUsed: "Tín dụng trả sau đã dùng",
  payments: "Thanh toán",
  paymentsListSettings: "Cài đặt danh sách cổng thanh toán",
  paymentsSettings: "Cài đặt thanh toán",
  paymentStatus: "Trạng thái thanh toán",
  paymentType: "Loại thanh toán",
  paymentTerms: "Điều khoản thanh toán:",
  pending: "Đang chờ",
  percentage: "Phần trăm",
  percentageBetween: "Tỷ lệ phần trăm phải trong khoảng 1-100",
  permitNumberWithColonSymbol: "Số giấy phép:",
  perPage: "{0} mỗi trang",
  phone: "Điện thoại",
  phoneNo: "Số liên hệ",
  pleaseCheckYourNetwork: "Vui lòng kiểm tra mạng để cập nhật dữ liệu địa điểm.",
  pleaseChooseLocation: "Vui lòng chọn vị trí",
  pleaseConnectToAnAccounting: "Vui lòng kết nối tích hợp kế toán để quản lý Hệ thống tài khoản.",
  pleaseContactOwnerToReactiveVenue: "Vui lòng liên hệ chủ địa điểm để gia hạn gói đăng ký và kích hoạt lại địa điểm này.",
  pleaseContactSupportRenewSubscription: "Vui lòng liên hệ bộ phận hỗ trợ để gia hạn gói đăng ký và kích hoạt lại địa điểm.",
  pleaseCopyUrl: "Vui lòng sao chép URL bên dưới và dán vào trình duyệt hoặc quét mã QR:",
  pleaseCopyUrlApk: "Nếu thiết bị không có Google Play Store, vui lòng tải ứng dụng từ URL bên dưới hoặc dùng thiết bị quét mã QR: ",
  pleaseCreateAccounts: "Vui lòng tạo mã tài khoản từ nền tảng kế toán đã tích hợp.",
  pleaseCreateLocation: "Vui lòng tạo ít nhất 1 vị trí để phân bổ tồn kho cho hàng tồn kho này.",
  pleaseEmailUs: "Vui lòng gửi email cho chúng tôi tại {0} {1}",
  pleaseEnsureLocation: "Vui lòng đảm bảo vị trí không có giao dịch đang diễn ra trước khi bắt đầu kiểm kho.",
  pleaseEnterYourSFTP: "Vui lòng nhập thông tin máy chủ SFTP và thông tin đăng nhập.",
  pleaseFetchDataFromSiigoByClickingButtonBelow: "Vui lòng lấy dữ liệu từ Siigo bằng cách nhấn nút bên dưới",
  pleaseMakeSureToSyncAllDataBeforeDeleteApp: "Vui lòng đảm bảo đã đồng bộ mọi dữ liệu trước khi xóa ứng dụng.",
  pleaseReadThisInstructionCarefully: "Vui lòng đọc kỹ hướng dẫn này",
  pleaseRenewSubscription: "Vui lòng gia hạn gói đăng ký để kích hoạt lại địa điểm.",
  pleaseSelectLocation: "Vui lòng chọn vị trí.",
  pleaseSelectStockUnit: "Vui lòng chọn đơn vị tồn kho",
  pleaseUpgradeToUseLockedFeature: "Vui lòng nâng cấp gói để sử dụng tính năng bị khóa này.",
  pointOfSale: "Máy bán hàng (POS)",
  posAndOnlineMenu: "POS + Thực đơn trực tuyến",
  posDevices: "Thiết bị bán hàng (POS)",
  posOnly: "Chỉ POS",
  posProvider: "Nhà cung cấp POS",
  postpaidCreditLimit: "Hạn mức tín dụng trả sau",
  postpaidCredits: "Tín dụng trả sau",
  postPaidCreditsIsTheAmount: "Tín dụng trả sau là số tiền khách có thể sử dụng khi số dư về 0. Khi khách có số dư tín dụng trả sau, khoản tiền này cần được thanh toán qua nạp tiền hoặc khi check-out",
  postpaidCreditsLiabilityAccount: "Tài khoản nợ phải trả tín dụng trả sau",
  postpaidCreditsLiabilityAccountMessage: "Tín dụng được sử dụng khi số dư của khách về 0. Sẽ được thanh toán qua nạp tiền khi check-out.",
  postpaidCreditsLiabilityAccountPlaceholder: "Tài sản/Tín dụng trả sau",
  postPaidCreditsUsed: "Tín dụng trả sau đã dùng",
  postpaidCreditsUsed: "Tín dụng trả sau đã dùng",
  postpaidCreditsUsedCanOnlyBeReplenished: "Tín dụng trả sau đã dùng chỉ có thể được bù và thanh toán qua nạp tiền hoặc khi check-out.",
  socashlessConnect: "SoCashlessCONNECT",
  socashlessLogo: "Logo SoCashless",
  socashless: "SoCashless",
  socashlessPaymentMethod: "Phương thức thanh toán SoCashless",
  socashlessTax: "Thuế SoCashless",
  socashlessPay: "SoCashlessPAY",
  powerYourVenue: "Tăng sức mạnh cho địa điểm với các tích hợp.",
  preloadedCredit: "Tín dụng nạp sẵn",
  preloadedVouchers: "Voucher nạp sẵn",
  prepareImport: "Đang chuẩn bị nhập",
  preparingReport: "Đang chuẩn bị báo cáo",
  previousBalance: "Số dư trước",
  price: "Giá",
  pricePerOrderQty: "Giá theo SL đặt",
  pricing: "Giá",
  pricingAndTaxes: "Giá và thuế",
  printableItems: "Mặt hàng được in",
  printableItemsSelect: "Chọn mặt hàng sẽ được in trên hồ sơ máy in này.",
  printerLocationsDesc: "Chọn vị trí có thể sử dụng hồ sơ máy in này.",
  printerProfile: "Hồ sơ máy in",
  printerProfileCreated: "Đã tạo hồ sơ máy in “{0}”.",
  printerProfileDeleted: "Đã xóa hồ sơ máy in",
  printerProfileName: "Tên hồ sơ máy in",
  printerProfileNameAlreadyExists: "Tên hồ sơ máy in này đã tồn tại.",
  printerProfiles: "Hồ sơ máy in",
  printerProfileUpdated: "Đã cập nhật hồ sơ máy in “{0}”.",
  printers: "Máy in",
  prioritizedAndUsedFirst: "được ưu tiên sử dụng trước khi thanh toán.",
  privacy: "Quyền riêng tư",
  privacyPolicy: "chính sách quyền riêng tư",
  privacyPolicy2: "Chính sách quyền riêng tư",
  proceed: "Tiếp tục",
  proceedToCheckout: "Tiến hành thanh toán",
  processingTransactions: "Đang xử lý giao dịch...",
  product: "Mặt hàng",
  productCategories: "Danh mục mặt hàng",
  productCategory: "Danh mục mặt hàng",
  productCodeInSiigo: "Mã mặt hàng trên Siigo",
  productCount: "Số lượng mặt hàng",
  productDeleted: "Đã xóa mặt hàng \"{0}\".",
  productForTips: "Mặt hàng cho tiền tip",
  productList: "Danh sách mặt hàng",
  productName: "Tên mặt hàng",
  productRedeemed: "Mặt hàng đã đổi",
  productRemovedFromInventory: "Đã xóa {0} mặt hàng khỏi kho.",
  products: "Mặt hàng",
  productsArePartOfComposite: "Những mặt hàng này là thành phần của mặt hàng tổng hợp khác. Để xóa, hãy gỡ chúng khỏi mặt hàng tổng hợp trước hoặc xóa {0} cùng với các mặt hàng tổng hợp chứa chúng.  ",
  productsAreSupplyItemsAre: "{0} là các mặt hàng bạn bán tại địa điểm. {1} là các thành phần dùng để tạo nên mặt hàng. Hàng tồn kho được quản lý trong {2}.",
  productsCanBeRedeemed: "Chọn mặt hàng có thể đổi bằng voucher này.",
  productsDeleted: "Đã xóa {0} mặt hàng.",
  productsDoesNotExist: "Các mặt hàng bạn muốn thêm phải tồn tại ở tất cả vị trí.",
  productSet: "Bộ mặt hàng",
  productSetDeleted: "Đã xóa bộ mặt hàng \"{0}\".",
  productSetName: "Tên bộ mặt hàng",
  productSettings: "Cài đặt mặt hàng",
  productsForDeletion: "{0} mặt hàng tại vị trí này cũng sẽ bị xóa. Hành động này không thể hoàn tác.",
  productsRemovedFromInventory: "Đã xóa {0} mặt hàng khỏi kho.",
  productsToBeDeleted: "Mặt hàng sẽ bị xóa",
  productsUpdated: "Đã cập nhật {0} mặt hàng.",
  productsVariants: "Mặt hàng / Biến thể",
  productsVSupplyItems: "Mặt hàng và Hàng tồn kho",
  productsWithNoCategory: "Đây là các mặt hàng chưa có danh mục",
  productUpdated: "Đã cập nhật {0} mặt hàng.",
  profile: "Hồ sơ",
  profileDiscount: "Giảm giá theo hồ sơ",
  profileDiscountDescription: "Chọn mức giảm giá theo phần trăm áp dụng cho tổng chi tiêu của khách này",
  profileDiscountRange: "Tỷ lệ phần trăm phải trong khoảng 1-100",
  profileName: "Tên hồ sơ",
  profileNameAlreadyExists: "Tên hồ sơ đã tồn tại, vui lòng nhập tên khác.",
  propertyManagementSystem: "Hệ thống quản lý cơ sở lưu trú",
  propertyManagementSystemExample: "Các hệ thống như MEWS và Cloudbeds",
  purchasePlus: "PurchasePlus",
  purchaseplus: "Purchase Plus",
  purchasingAndInventory: "Mua hàng và kho hàng",
  qrCodeForOnlineMenu: "Mã QR cho thực đơn trực tuyến",
  qty: "SL",
  quantity: "Số lượng",
  quantitySupplyItems: "Số lượng hàng tồn kho dùng cho mặt hàng này.",
  quarter: "Quý",
  quarterly: "Hằng quý",
  question: "Câu hỏi",
  questionAddedName: "Đã thêm câu hỏi “{0}“.",
  questionAlreadyExist: "Câu hỏi đã tồn tại.",
  questionDeleted: "Đã xóa câu hỏi “{0}“.",
  questionDescription: "Thông tin cần thu thập khi đăng ký khách. Sử dụng các câu hỏi này bằng cách gán cho {0}.",
  questions: "Câu hỏi",
  questionSettings: "Cài đặt câu hỏi",
  radioButton: "Nút chọn một",
  reachedReorderPoint: "Đã đạt điểm đặt hàng lại",
  readyForDownload: "sẵn sàng để tải xuống",
  reallyUnbanTag: "Bạn thực sự muốn bỏ chặn thẻ này?",
  reallyUnbanThisTagDescription: "Việc bỏ chặn thẻ này chỉ có hiệu lực ở lần đồng bộ và cập nhật thiết bị tiếp theo (thường mỗi 5 phút khi có kết nối internet). Để áp dụng ngay, vui lòng đồng bộ và cập nhật thiết bị sau khi bỏ chặn thẻ.",
  reason: "Lý do",
  reasonsForStay: "Lý do lưu trú",
  receiptFormatting: "Định dạng hóa đơn",
  receiptNumber: "Số hóa đơn",
  receipts: "Hóa đơn",
  receiptSettings: "Cài đặt hóa đơn",
  recentTransactions: "Giao dịch gần đây",
  reconnect: "Kết nối lại",
  redeem: "Đổi",
  redeemableProducts: "Mặt hàng có thể đổi",
  redeemed: "Đã đổi",
  referenceNo: "Số tham chiếu",
  refreshingThisPage: "Tải lại trang này",
  refundedCredits: "Tín dụng đã hoàn",
  registeredBusinessInformation: "Thông tin doanh nghiệp đã đăng ký",
  registeredBusinessTaxNumber: "Mã số thuế doanh nghiệp",
  registeredOfficialBusinessName: "Tên doanh nghiệp đã đăng ký/chính thức",
  registerGuests: "Đăng ký khách",
  registerGuestsRoleAppDesc: "Vai trò này không có quyền truy cập trang web.",
  registerGuestsRoleDashboardDesc: "Cho phép truy cập chức năng Check-in và Check-out khách trên ứng dụng.",
  registerInfo: "Thông tin ca",
  registerReports: "Báo cáo ca",
  shifts: "Ca làm việc",
  registerReportsPage: "Trang báo cáo ca",
  registerStaff: "Đăng ký nhân viên",
  regulateEntryExit: "Kiểm soát Vào/Ra",
  regulateEntryExitDesc: "Bật tính năng này cho phép kiểm soát chính xác lượt vào và ra tại điểm ra vào.\nKhi tắt, kiểm soát ra vào vẫn hoạt động nhưng sẽ không phân biệt lượt vào và lượt ra.",
  remove: "Xóa",
  removedStock: "Tồn kho đã xóa",
  removeFreeCredits: "Xóa tín dụng miễn phí",
  removeFromList: "Xóa khỏi danh sách",
  removeNameAsYourStaff: "Xóa {0} khỏi danh sách nhân viên?",
  removeSku: "SKU đã xóa",
  removeStaff: "Xóa nhân viên?",
  removeStocks: "Xóa tồn kho?",
  removeStocksConfirm: "Xóa tồn kho",
  removeStocksDetails: "Bạn có chắc muốn xóa {0} {1} tồn kho của {2} tại {3}?",
  removeThisAccount: "Xóa tài khoản này?",
  removeThisSupplyItem: "Hãy gỡ hàng tồn kho này khỏi các mặt hàng trước khi xóa.",
  removeVariant: "Xóa biến thể",
  removeVariantFirstFromProduct: "Hãy gỡ biến thể này khỏi mặt hàng trước",
  renewSubscription: "Gia hạn gói đăng ký",
  reorderPoint: "Điểm đặt hàng lại",
  reorderPointReached: "Đã đạt điểm đặt hàng lại",
  reorderStocks: "Đặt thêm hàng",
  report: "Báo cáo",
  reportAProblem: "Báo cáo sự cố",
  reportingDay: "Ngày báo cáo",
  reports: "Báo cáo",
  reportsFailedToLoad: "Tải báo cáo thất bại.",
  reportsInfoPage: "Trang thông tin báo cáo",
  required: "Bắt buộc",
  requireManagerAuthorization: "Yêu cầu quản lý phê duyệt khi áp dụng giảm giá này.",
  requireManagerAuthorizationVoucher: "Yêu cầu quản lý phê duyệt khi phát hành voucher này.",
  resendInvite: "Gửi lại lời mời?",
  resetExpiration: "Đặt lại thời hạn",
  resetTheExpirationPeriod: "Đặt lại thời hạn khi khách hoàn tất giao dịch mà không check-in.",
  restrictUseOfTags: "Hạn chế sử dụng một số thẻ tại địa điểm của bạn.",
  resync: "Đồng bộ lại",
  resyncEInvoice: "Đồng bộ lại hóa đơn điện tử",
  resyncSuccessfully: "Đồng bộ lại thành công",
  retailPrice: "Giá bán lẻ",
  retailPriceMustNotBeNegative: "Giá bán lẻ không được âm",
  retryReloadingChart: "Thử tải lại biểu đồ",
  returnCredits: "Hoàn trả tín dụng",
  returnCreditsRoleAppDesc: "Vai trò này không có quyền truy cập trang quản trị Venue trực tuyến.",
  returnCreditsRoleDashboardDesc: "Cho phép truy cập chức năng Hoàn trả tín dụng trên ứng dụng Venue",
  returnedTags: "Thẻ đã trả",
  returnedVoucher: "Voucher đã trả",
  returningGuests: "Khách quay lại",
  revenue: "Doanh thu",
  revenueAccount: "Tài khoản doanh thu",
  revenueAccountMessage: "Tài khoản mặc định cho toàn bộ doanh thu bán hàng.",
  revenueAccountPlaceholder: "Doanh thu/Bán hàng",
  reviewYourDailyVenueActivity: "Xem lại hoạt động hằng ngày của địa điểm. ",
  revokeInvite: "Thu hồi lời mời",
  revokeThisInvite: "Thu hồi lời mời này?",
  roadMap: "Lộ trình phát triển",
  role: "Vai trò",
  roleAndDesignation: "Vai trò và vị trí làm việc",
  roles: "Vai trò",
  rooms: "Phòng",
  runEndOfDay: "Chạy chốt cuối ngày",
  running: "Đang chạy",
  runningTheEodWithUnsynced: "Chạy EOD khi còn giao dịch chưa đồng bộ sẽ dẫn đến báo cáo không đầy đủ.",
  sale: "Bán hàng",
  saleDiscounts: "Doanh thu/Giảm giá bán hàng",
  saleFoc: "Doanh thu/Bán hàng FOC",
  saleReturn: "Trả hàng",
  sales: "Doanh thu",
  salesDiscounts: "Giảm giá bán hàng",
  salesDiscountsMessage: "Chi phí cho mọi khoản giảm giá đã áp dụng.",
  salesDiscountsPlaceholder: "Giảm giá bán hàng",
  salesFOC: "Bán hàng FOC",
  salesFOCMessage: "Chi phí cho mọi tín dụng miễn phí đã áp dụng.",
  salesFOCPlaceholder: "Doanh thu/Bán hàng FOC",
  salesInformation: "Thông tin bán hàng",
  salesOverTime: "Doanh thu theo thời gian",
  salesReport: "Báo cáo doanh thu",
  salesSummary: "Tóm tắt doanh thu",
  salesTax: "Thuế bán hàng",
  save: "Lưu",
  saveAccountSetting: "Lưu cài đặt tài khoản",
  saveCategoryForm: "Lưu biểu mẫu danh mục",
  saveCreditSetting: "Lưu cài đặt tín dụng",
  savedChanges: "Đã lưu thay đổi",
  saveDeviceForm: "Lưu biểu mẫu thiết bị",
  saveDiscountForm: "Lưu biểu mẫu giảm giá",
  saveGeneralSettings: "Lưu cài đặt chung",
  saveLocationForm: "Lưu biểu mẫu vị trí",
  saveNewSupplyItemForm: "Lưu biểu mẫu hàng tồn kho mới",
  savePaymentMethod: "Lưu phương thức thanh toán",
  savePrinterProfileForm: "Lưu biểu mẫu hồ sơ máy in",
  saveProduct: "Lưu mặt hàng",
  saveProductSet: "Lưu bộ mặt hàng",
  saveQuestion: "Lưu câu hỏi",
  saveReceiptSettings: "Lưu cài đặt hóa đơn",
  saveStaffForm: "Lưu biểu mẫu nhân viên",
  saveStaffProfileForm: "Lưu biểu mẫu hồ sơ nhân viên",
  saveTaxSetting: "Lưu cài đặt thuế",
  saveVenueForm: "Lưu biểu mẫu địa điểm",
  saveVoucherForm: "Lưu biểu mẫu voucher",
  saveWristbandKeepingSettings: "Lưu cài đặt giữ vòng đeo tay",
  scanningTheQRcode: "Quét mã QR",
  scanningTheQRcodeDesc: " Mở ứng dụng camera trên thiết bị và hướng camera vào mã QR được cung cấp. Thao tác này sẽ tự động mở liên kết tới trang ứng dụng trên Google Play Store.",
  scanningTheQRcodeOrUsingUrl: "Quét mã QR hoặc sử dụng URL",
  scanQRcode: "Quét mã QR",
  scheduleACall: "Đặt lịch gọi",
  search: "Tìm kiếm",
  search2: "Tìm kiếm...",
  searchBanTags: "Tìm thẻ bị chặn theo UID thẻ",
  searchBlockedTags: "Tìm thẻ bị chặn theo UID thẻ",
  searchCategories: "Tìm và chọn danh mục cho voucher này",
  searchEInvoicePlaceholder: "Tìm hóa đơn điện tử theo Số HĐ Siigo, tên khách hoặc số CUEF",
  searchForProducts: "Tìm mặt hàng hoặc hàng tồn kho",
  searchForStockId: "Tìm theo mã tồn kho...",
  searchForStocktakeId: "Tìm theo mã kiểm kho...",
  searchGuestsBalanceMovements: "Tìm khách theo tên hoặc ID thẻ",
  searchMovementPlaceholder: "Tìm biến động theo tên voucher, thiết bị, khách",
  searchPaymentGateway: "Tìm theo tên cổng thanh toán",
  searchProductByKeyOrSku: "Tìm mặt hàng theo từ khóa hoặc SKU",
  searchProductsByKeyword: "Tìm mặt hàng theo từ khóa",
  searchProductsIn: "Tìm mặt hàng trong {0}",
  searchReportsByShiftId: "Tìm báo cáo theo mã ca",
  searchResult: "kết quả tìm kiếm",
  searchResults: "kết quả tìm kiếm",
  searchStaffEmailOrTagID: "Tìm theo email nhân viên hoặc ID thẻ",
  searchSupplyItemBy: "Tìm hàng tồn kho theo tên hoặc SKU",
  searchTag: "Tìm thẻ",
  searchTransactionPlaceholder: "Tìm giao dịch theo mã giao dịch, ID thẻ, mã check-in",
  searchVouchers: "Tìm voucher",
  second: "giây",
  seconds: "giây",
  seeError: "Xem lỗi",
  selectAccessPoints: "Chọn điểm ra vào",
  selectAccount: "Chọn tài khoản",
  selectAccountType: "Chọn loại tài khoản",
  selectAndMakeComposition: "Chọn cách tạo và thành phần của mặt hàng này.",
  selectAType: "Chọn loại",
  selectCategoriesOrProducts: "Chọn danh mục hoặc mặt hàng từ các vị trí đã chọn",
  selectCategory: "Chọn danh mục",
  selectCharge: "Chọn phụ phí",
  selectCountry: "Chọn quốc gia",
  selectDevice: "Chọn thiết bị",
  selectGuestProfile: "Chọn hồ sơ khách",
  selectInventoryGroup: "Chọn nhóm kho hàng",
  selectInventoryGroupFormSiigoToAssign: "Chọn nhóm kho hàng từ Siigo để gán cho mặt hàng này",
  selectInvoiceType: "Chọn loại hóa đơn",
  selectItemsThisProductMadeOf: "Chọn các thành phần tạo nên mặt hàng này. Đặt số lượng mỗi hàng tồn kho sẽ bị trừ cho mỗi đơn bán mặt hàng này.",
  selectLocation: "Chọn vị trí",
  selectNumberOfTables: "Chọn số lượng bàn",
  selectOutlet: "Chọn vị trí",
  selectProductForTips: "Chọn mặt hàng cho tiền tip",
  selectProducts: "Chọn mặt hàng",
  selectRedeemableProducts: "Chọn mặt hàng có thể đổi",
  selectSeller: "Chọn người bán",
  selectSource: "Chọn nguồn",
  selectStaff: "Chọn nhân viên",
  selectStatus: "Chọn trạng thái",
  selectStockLevel: "Chọn mức tồn kho",
  selectStockUnit: "Chọn đơn vị tồn kho",
  selectSupplyItem: "Chọn hàng tồn kho",
  selectTax: "Chọn thuế",
  selectToIncludeCategory: "Chọn để thêm mặt hàng này vào danh mục..",
  selectToIncludeProductSetInCategory: "Chọn để thêm bộ mặt hàng này vào danh mục..",
  selectVenue: "Chọn địa điểm",
  selectVouchers: "Chọn voucher",
  seller: "Người bán",
  selling: "Đang bán",
  sellingOnPos: "Đang bán trên POS",
  sellingQty: "SL bán",
  sellingQtyMustBeGreaterThanZero: "Số lượng bán phải lớn hơn 0.",
  sellOnPos: "Bán trên POS",
  sellOnPosRoleAppDesc: "Vai trò này không có quyền truy cập trang web.",
  sellOnPosRoleDashboardDesc: "Cho phép truy cập chức năng Bán hàng POS trên ứng dụng",
  sendTo: "Gửi tới",
  sendToDian: "Gửi tới Dian",
  sendToDianSuccessfully: "Gửi tới Dian thành công",
  sendToSiigo: "Gửi tới Siigo",
  sendToSiigoSuccessfully: "Gửi tới Siigo thành công",
  serialNumber: "Số serial",
  serialNumberAbbv: "S/N",
  set: "Đặt",
  setAnAmountToLimitPostPaid: "Đặt số tiền để giới hạn tín dụng trả sau cho phép của khách.",
  setAsDefaultTax: "Đặt làm thuế mặc định",
  setAsNonRefundable: "Đặt là không hoàn lại",
  setCode: "Mã bộ",
  setDefaultPaymentGateway: "Đặt cổng thanh toán mặc định",
  setExpirationPeriod: "Đặt thời hạn hết hạn",
  sets: "Bộ",
  settings: "Cài đặt",
  setUpYourAccount: "Thiết lập tài khoản của bạn!",
  setUpYourSoCashlessAccount: "Thiết lập tài khoản SoCashless của bạn",
  setupYourPaymentGateways: "Thiết lập cổng thanh toán",
  share: "Chia sẻ",
  shareThisLink: "Chia sẻ liên kết này để mở {0} trên mọi thiết bị! Sao chép liên kết và chia sẻ với nhân viên của bạn.",
  shift: "Ca",
  shiftAlreadyClosed: "Ca này đã được đóng.",
  shiftClosed: "Đã đóng ca",
  shiftEnd: "Kết thúc ca",
  shiftId: "Mã ca",
  shiftsAndTransactions: "Ca và giao dịch",
  shiftStart: "Bắt đầu ca",
  shouldBeANumber: "Phải là số.",
  show: "Hiển thị",
  showErrorInvoiceOnly: "Chỉ hiển thị hóa đơn lỗi",
  showHideColumns: "Hiện / Ẩn cột",
  showLess: "Thu gọn",
  showMore: "Xem thêm",
  showNumOutDateDevices: "Hệ thống cho thấy chỉ có {0} thiết bị đã cập nhật lên phiên bản mới nhất. Vui lòng cập nhật các thiết bị còn lại lên phiên bản mới nhất.",
  showOnlineMenu: "Hiển thị trên thực đơn trực tuyến",
  signIn: "Đăng nhập",
  signInButton: "Nút đăng nhập",
  signUp: "Đăng ký",
  siigo: "Siigo",
  siigoAccount: "Tài khoản Siigo",
  siigoAccountConnectedToDian: "Tài khoản Siigo đã kết nối với Dian",
  siigoDescBill: "Loại giảm giá cần được cấu hình là 'Percentage' và đang hoạt động trên Siigo.",
  siigoDescInventoryGroup: "Trong Siigo, nhóm kho hàng dùng để sắp xếp và phân loại các mặt hàng tương tự. Nếu mặt hàng tại địa điểm chưa được gán nhóm kho cụ thể, nó sẽ tự động được đưa vào Nhóm kho mặc định.",
  siigoDescPaymentMethod: "Nhập tên mặt hàng hoặc dịch vụ mà tiền tip sẽ được liên kết. Mặt hàng này sẽ được tạo (hoặc cập nhật nếu đã tồn tại) trên Siigo và liên kết với tiền tip tại địa điểm để xuất hóa đơn.",
  siigoDescProductForTips: "Mặt hàng sẽ được dùng để xuất hóa đơn cho tiền tip bạn nhận được",
  siigoDescSalesTax: "Liên kết thuế trên SoCashless với thuế tương ứng trên Siigo. Nếu bạn không chọn thuế trên Siigo, các hóa đơn có thuế này sẽ không được tạo.",
  siigoDescSeller: "Người bán này sẽ là người bán cho hóa đơn được tạo trên Siigo",
  siigoError: "Lỗi Siigo",
  siigoIntegrationDetail: "Chi tiết tích hợp Siigo",
  siigoInvNo: "Số HĐ Siigo",
  siigoInvoiceNumber: "Số hóa đơn Siigo:",
  sku: "SKU",
  skuAlreadyExists: "SKU đã tồn tại.",
  skuStockKeepingUnit: "SKU (Mã quản lý tồn kho)",
  someArePartOfCompositeNote: "{0} {1} bên dưới không thể xóa vì là thành phần của mặt hàng tổng hợp khác. Để xóa, hãy gỡ chúng khỏi mặt hàng tổng hợp hoặc xóa {2} cùng với các mặt hàng tổng hợp chứa chúng.",
  someShiftsHaveUnsynced: "Một số ca có giao dịch chưa đồng bộ. Vui lòng kiểm tra thiết bị của các ca đó để đẩy dữ liệu địa điểm.",
  somethingWentWrong: "Đã xảy ra lỗi.",
  somethingWentWrongPlsTryAgain: "Đã xảy ra lỗi. Vui lòng thử lại",
  sorryVenueSuspended: "Rất tiếc, địa điểm này đã bị tạm ngưng.",
  source: "Nguồn",
  sourceLocation: "Vị trí nguồn",
  sourceLocationOriginalQty: "SL ban đầu tại vị trí nguồn",
  sourceLocationRemainQty: "SL còn lại tại vị trí nguồn",
  sourceLocationTransferQty: "SL chuyển từ vị trí nguồn",
  specificCategories: "Danh mục cụ thể",
  specificProducts: "Mặt hàng cụ thể",
  spend: "Chi tiêu",
  split: "Chia",
  splitInfo: "Thông tin chia",
  splitShare: "Phần chia",
  paymentMode: "Hình thức thanh toán",
  edited: "Đã chỉnh sửa",
  staff: "Nhân viên",
  staffCanAccess: "Nhân viên có thể truy cập ứng dụng POS và thực hiện thao tác.",
  staffList: "Danh sách nhân viên",
  staffName: "Tên nhân viên",
  staffNameAndOrTagId: "Tên nhân viên và/hoặc ID thẻ",
  staffNote: "Ghi chú nhân viên",
  staffProfile: "Hồ sơ nhân viên",
  staffProfileDeleted: "Đã xóa hồ sơ nhân viên",
  staffProfileList: "Danh sách hồ sơ nhân viên",
  staffProfileName: "Tên hồ sơ nhân viên",
  staffProfileNameCreated: "Đã tạo hồ sơ nhân viên “{0}”.",
  staffProfileNamePlaceholder: "Nhập tên hồ sơ nhân viên này...",
  staffProfiles: "Hồ sơ nhân viên",
  staffRemoved: "Đã xóa nhân viên.",
  staffTagWithColonSymbol: "Thẻ nhân viên:",
  staffWithColonSymbol: "Nhân viên:",
  standard: "Tiêu chuẩn",
  start: "Bắt đầu",
  startedOn: "Bắt đầu lúc",
  startStocktake: "Bắt đầu kiểm kho",
  state: "Trạng thái",
  status: "Trạng thái",
  staying: "Đang lưu trú",
  step: "Bước",
  stockAdjSupplyItemsTxtConfirm: "Bạn có chắc muốn điều chỉnh tồn kho cho các hàng tồn kho tại {0}",
  stockAdjustment: "Điều chỉnh tồn kho",
  stockBelowParLevel: "Tồn kho dưới mức tối thiểu",
  stockLevel: "Mức tồn kho",
  stockLevelAlerts: "Cảnh báo mức tồn kho",
  stockLevelNotificationSettings: "Cài đặt thông báo mức tồn kho",
  stockLevels: "Mức tồn kho",
  stockManager: "Quản lý kho",
  stockManagerRoleAppDesc: "Vai trò này không có quyền liên quan đến ứng dụng và sẽ không thể đăng nhập trên thiết bị.",
  stockManagerRoleDashboardDesc: "Cho phép truy cập trang quản trị Venue, chỉ giới hạn ở chức năng Kiểm kho.",
  stockReachedReorderPoint: "Tồn kho đã đạt điểm đặt hàng lại",
  stocks: "Tồn kho",
  stocktake: "Kiểm kho",
  stocktakeAlreadyExists: "Phiếu kiểm kho đã tồn tại",
  stocktakeSaved: "Đã lưu phiếu kiểm kho",
  stocktakeWithId: "Kiểm kho #ST-{0}",
  stockUnit: "Đơn vị tồn kho",
  stockVariance: "Chênh lệch tồn kho",
  stockWeightPerN: "Khối lượng tồn kho mỗi {0}",
  streetVillage: "Địa chỉ, Phường / Xã",
  subscribeAndRegister: "Đăng ký gói ngay để nhận",
  subscription: "Gói đăng ký",
  subscription_only_owner_access: "Chỉ Chủ địa điểm đã đăng ký gói này mới có thể truy cập",
  subscriptionCanceledReason: "Bạn đã hủy gói đăng ký.",
  subscriptionExpiredReason: "Bạn đã hủy gói đăng ký.",
  subscriptionSuspended: "Gói đăng ký đã kết thúc. Vui lòng liên hệ chủ địa điểm để gia hạn trước {1} để giữ quyền truy cập {2}.",
  subscriptionSuspendedIn5: "Địa điểm này sẽ bị tạm ngưng sau 5 ngày. Vui lòng liên hệ chủ địa điểm để gia hạn gói trước {0} để giữ quyền truy cập {1}.",
  subscriptionSuspendedIn5Manager: "Địa điểm của bạn sẽ bị tạm ngưng trong vòng chưa đầy 5 ngày. Vui lòng gia hạn gói trước {0} để giữ quyền truy cập {1}.",
  subscriptionSuspendedManager: "{0} Vui lòng gia hạn gói trước {1} để giữ quyền truy cập {2}.",
  subscriptionSuspendedToday: "Địa điểm của bạn sẽ bị tạm ngưng hôm nay. Vui lòng liên hệ chủ địa điểm để gia hạn gói và giữ quyền truy cập {0}.",
  subscriptionSuspendedTodayManager: "Địa điểm của bạn sẽ bị tạm ngưng hôm nay. Vui lòng gia hạn gói ngay hôm nay để giữ quyền truy cập {0}.",
  subscriptionUnpaidReason: "Có vẻ có vấn đề với thông tin thanh toán của bạn.",
  subTotal: "Tạm tính",
  success: "Thành công",
  sugar: "đường",
  suggested: "Đề xuất",
  summary: "Tóm tắt",
  supervisor: "Giám sát",
  supervisorRoleAppDesc: "Vai trò này có quyền truy cập ứng dụng và quyền hạn chế trên trang web",
  supervisorRoleDashboardDesc: "Cho phép toàn quyền trên ứng dụng, và truy cập Đặt chỗ, Khách, Giao dịch, Báo cáo, Thiết bị và Chặn thẻ",
  supplyCost: "Chi phí nguyên liệu",
  supplyItem: "Hàng tồn kho",
  supplyItemAlreadyExists: "Tên hàng tồn kho đã tồn tại.",
  supplyItemDeleted: "Đã xóa hàng tồn kho",
  supplyItemNameCreated: "Đã tạo hàng tồn kho “{0}”.",
  supplyItems: "Hàng tồn kho",
  stock: "Tồn kho",
  stockTransfers: "Chuyển kho",
  supplyItemSummaryPage: "Trang tóm tắt hàng tồn kho",
  supplyTaxes: "Thuế nguyên liệu",
  supplyUnit: "Đơn vị nguyên liệu",
  supplyValue: "Giá trị nguyên liệu",
  supportSocashless: "support@socashless.com",
  suspended: "Đã tạm ngưng",
  syncFromSiigo: "Đồng bộ từ Siigo",
  syncFromSiigoDesc: "Nếu bạn thêm hoặc cập nhật thông tin trên Siigo (loại hóa đơn, người bán, nhóm kho hàng, phương thức thanh toán hoặc thuế), bạn cần đồng bộ lại để liên kết với mục tương ứng trên SoCashless.",
  syncFromSiigoSuccessfully: "Đồng bộ từ Siigo thành công",
  syncToDian: "Đồng bộ tới Dian",
  syncToMews: "Đồng bộ tới MEWS",
  tableManagement: "Quản lý bàn",
  tableQRCode: "Mã QR bàn (mỗi bàn một mã)",
  tables: "Bàn",
  tagBanned: "Đã chặn thẻ.",
  tagId: "ID thẻ",
  tagIds: "ID thẻ",
  tagInfo: "Thông tin thẻ",
  tags: "Thẻ",
  tagsIssued: "Thẻ đã phát hành",
  tagUID: "UID thẻ",
  tagUnbanned: "Đã bỏ chặn thẻ.",
  tapCount: "Số lượt quẹt",
  tapOnTheAPKFileToStartTheInstallationProcess: "Nhấn vào tệp APK để bắt đầu cài đặt. Làm theo hướng dẫn trên màn hình để hoàn tất. Sau khi cài đặt, mở ứng dụng từ danh sách ứng dụng hoặc màn hình chính.",
  tapStatus: "Trạng thái quẹt",
  tax: "Thuế",
  taxAddedName: "Đã thêm thuế “{0}“.",
  taxAlreadyExists: "Thuế đã tồn tại.",
  taxCode: "Mã thuế",
  taxEditNote: "Lưu ý: Các mặt hàng liên kết với thuế này sẽ được cập nhật tự động. Điều này không ảnh hưởng đến doanh thu trước đó.",
  taxEg: "VD: “Thuế giá trị gia tăng“",
  taxes: "Thuế",
  taxIncluded: "Đã bao gồm thuế",
  taxInvoiceNo: "Số hóa đơn thuế#:",
  taxInvoiceNumber: "Số hóa đơn thuế",
  taxName: "Tên thuế",
  taxNumber: "Mã số thuế",
  taxOnPurchasesAccount: "Tài khoản thuế mua hàng",
  taxOnPurchasesAccountMessage: "VAT và các loại thuế khác trên đơn mua hàng.",
  taxOnPurchasesAccountPlaceholder: "Nợ phải trả/Thuế mua hàng",
  taxOnSalesLiabilityAccount: "Tài khoản nợ phải trả thuế bán hàng",
  taxOnSalesLiabilityAccountMessage: "Tài khoản mặc định cho thuế tính trên mỗi mặt hàng.",
  taxOnSalesLiabilityAccountPlaceholder: "Nợ phải trả/Thuế bán hàng",
  taxPercentageAndValue: "Thuế ({0}%): {1}",
  taxRate: "Thuế suất",
  taxSettings: "Cài đặt thuế",
  termsAndConditions: "Điều khoản và điều kiện",
  termsInAllowingAccess: "Khi nhấn Cho phép truy cập, bạn ủy quyền cho {0} sử dụng, nhận và lưu trữ thông tin của bạn. Vui lòng xem {2} và {3} của {1}. Bạn có thể dừng bất cứ lúc nào trong phần Cài đặt tích hợp của tài khoản SoCashless.",
  termsInAllowingAccess2: "Khi nhấn Cho phép truy cập, bạn ủy quyền cho {0} sử dụng, nhận và lưu trữ thông tin của bạn. Bạn có thể dừng bất cứ lúc nào trong phần Cài đặt tích hợp của tài khoản SoCashless.",
  termsInAllowingAccess3: "Khi nhấn Cho phép truy cập, bạn ủy quyền cho {0} lưu trữ thông tin {1} của bạn. Vui lòng xem {2} và {3} của chúng tôi.",
  siigoSendInvoiceError: "Lỗi khi gửi hóa đơn. Vui lòng nhấn vào số hóa đơn tương ứng để biết thêm thông tin.",
  termsInSignUp: "Khi đăng ký, tôi đồng ý với {0}, {1} và {2} của SoCashless.",
  termsInSoCashlessSignUp: "Khi đăng ký, tôi đồng ý với {0} của SoCashless",
  termsOfService: "điều khoản dịch vụ",
  termsOfUse: "Điều khoản sử dụng",
  textbox: "Ô nhập văn bản",
  theActualNumberOfGuests: "Số khách thực tế đã check-in/check-out",
  theAmountTheGuestWillPay: "Đây là số tiền khách sẽ trả cho lượt đặt chỗ.",
  theBookingStatus: "Trạng thái đặt chỗ từ nguồn.",
  theGuestHasNoAssignedRoom: "Khách chưa được gán phòng!",
  theLastVersion: "Phiên bản ứng dụng mới nhất: ",
  theLastVersionOfAppAvailable: "Phiên bản mới nhất của ứng dụng {0} đã có trên Google Play Store.",
  theLinkYouAreTryingToAccess: "Liên kết bạn đang truy cập không thuộc địa điểm của bạn.",
  theLinkYouAreTryingToAccessDoesNotBelongToLocation: "Liên kết bạn đang truy cập không thuộc vị trí được gán cho bạn",
  thereIsSomeError: "Ôi! Đã có lỗi từ phía chúng tôi. Vui lòng thông cảm và kiểm tra lại sau.",
  theseNthOtherProducts: "{0} {1} mặt hàng khác tại vị trí này và các vị trí khác sẽ vẫn còn trong kho.",
  theseProductsCannotBeDeleted: "Không thể xóa các mặt hàng này.",
  theShiftAndTransactionDetails: "Chi tiết ca và giao dịch sẽ hiển thị tại đây khi ca được đóng trên máy.",
  theUpdateShouldBeAppliedAutomatically: "Bản cập nhật sẽ được áp dụng tự động, nhưng bạn cũng có thể mở liên kết bên dưới hoặc quét mã QR để tải phiên bản mới nhất.",
  thisAppRequests: "Ứng dụng này yêu cầu các thông tin sau:",
  thisAppWouldRead: "Ứng dụng này sẽ đọc và/hoặc ghi các thông tin sau:",
  thisEmailIsAlreadyAdded: "Email này đã được thêm.",
  thisEmailIsInvalid: "Email này không hợp lệ.",
  thisFieldIsRequired: "Trường này là bắt buộc.",
  thisGuestHasNotCheckedOutYet: "Khách này chưa check-out",
  thisIsForDirectIntegrationWithPaymentTerminalPartner: "Dành cho tích hợp trực tiếp với đối tác thiết bị thanh toán",
  thisLocationHasTables: "Vị trí này có bàn và sắp xếp chỗ ngồi.",
  thisMonth: "Tháng này",
  thisProductNameAlreadyExists: "Tên mặt hàng này đã tồn tại",
  thisProductsHasMultipleVariant: "Mặt hàng này có nhiều tùy chọn như kích cỡ, màu sắc, hương vị, v.v.",
  thisQuestionIsLinkedToNProfiles: "Câu hỏi này được liên kết với {0} hồ sơ khách.",
  thisServesAsAnOfficialReceipt: "- ĐÂY LÀ HÓA ĐƠN CHÍNH THỨC -",
  thisShiftHasUnsyncedTransactions: "Ca này có giao dịch chưa đồng bộ",
  thisSkuExists: "SKU này đã tồn tại",
  thisStaffHasNpLongerAccess: "Nhân viên này sẽ không còn quyền truy cập {0}. Hành động này không thể hoàn tác.",
  thisTagIdIsAlreadyBanned: "ID thẻ này đã bị chặn.",
  thisUrlIsInvalid: "URL này không hợp lệ.",
  thisVenueFreeTrial: "Địa điểm này sẽ được dùng thử miễn phí trong 30 ngày đầu.",
  thisWeek: "Tuần này",
  ticketing: "Bán vé",
  ticketNo: "Số vé",
  time: "Thời gian",
  timeEnded: "Thời gian kết thúc",
  timeout: "Hết thời gian chờ",
  timeRange: "Khoảng thời gian",
  timeStarted: "Thời gian bắt đầu",
  tip: "Tiền tip",
  tipOptions: "Tùy chọn tiền tip",
  tipReport: "Báo cáo tiền tip",
  tips: "Tiền tip",
  tipsAndCharges: "Tiền tip và phụ phí",
  to: "đến",
  toAddMoreCreditsToATag: "Để nạp thêm tín dụng vào thẻ, khách có thể",
  toBeCheckedIn: "Chờ check-in",
  toBeCheckedOut: "Chờ check-out",
  toContinueCreatingDiscount: "Để tiếp tục tạo giảm giá này, hãy tạo vị trí trước.",
  toContinueCreatingProducts: "Để tiếp tục tạo mặt hàng này, hãy tạo vị trí trước.",
  toContinueCreatingStaff: "Để tiếp tục tạo nhân viên này, hãy tạo vị trí trước.",
  toContinueCreatingStocktake: "Để tiếp tục tạo phiếu kiểm kho này, hãy tạo vị trí trước.",
  today: "Hôm nay",
  toDeleteItem: "để xóa mặt hàng này.",
  together: "cùng lúc",
  topCategoriesBySales: "Danh mục bán chạy nhất",
  topLocations: "Vị trí hàng đầu",
  topProducts: "Mặt hàng bán chạy",
  topSpendingGuests: "Khách chi tiêu nhiều nhất",
  topupAndReturnCredits: "Nạp và hoàn trả tín dụng",
  topupCredits: "Nạp tín dụng",
  topupCreditsRoleAppDesc: "Vai trò này không có quyền truy cập trang web.",
  topupCreditsRoleDashboardDesc: "Cho phép truy cập chức năng Nạp tiền trên ứng dụng",
  toScheduleACall: "để đặt lịch gọi với bộ phận chăm sóc khách hàng.",
  total: "Tổng",
  totalAmount: "Tổng số tiền",
  totalBookings: "Tổng lượt đặt chỗ",
  totalCreditsKept: "Tổng tín dụng được giữ lại (sau check-out)",
  totalCreditsKeptByGuests: "Tổng tín dụng khách giữ lại",
  totalCreditsKeptTooltip: "Tổng số tín dụng khách giữ lại sau khi check-out",
  totalCreditsReceived: "Tổng tín dụng nhận được",
  totalCreditsReceivedFromVenues: "Tổng tín dụng nhận từ địa điểm khác",
  totalCreditsReceivedTooltip: "Tổng số tín dụng nhận được từ khách check-in với tín dụng giữ lại từ địa điểm khác",
  totalExpectedEndingBalance: "Tổng số dư cuối dự kiến",
  totalFreeCreditsIssued: "Tổng tín dụng miễn phí đã cấp",
  totalFreeCreditsRemoved: "Tổng tín dụng miễn phí đã xóa",
  totalInStock: "Tổng tồn kho",
  totalItems: "Tổng số mặt hàng",
  totalOpeningBalance: "Tổng số dư đầu ca",
  totalPaid: "Tổng đã thanh toán",
  totalProductSales: "Tổng doanh thu mặt hàng",
  totalDue: "Tổng phải trả",
  totalRefunded: "Tổng đã hoàn",
  totalRefundedCredits: "Tổng tín dụng đã hoàn",
  totalRemoved: "Tổng đã xóa",
  totalReturnCredits: "Tổng tín dụng hoàn trả",
  totalReturnedCredits: "Tổng tín dụng đã hoàn trả",
  totals: "Tổng cộng",
  totalSales: "Tổng doanh thu",
  totalSpent: "Tổng chi tiêu",
  totalSpentToDate: "Tổng chi tiêu đến nay",
  totalStocksPerLocation: "Tổng tồn kho mỗi vị trí",
  totalTagsUsed: "Tổng thẻ đã phát hành",
  totalTax: "Tổng thuế",
  totalTopupCredits: "Tổng tín dụng nạp",
  totalTopUps: "Tổng lượt nạp",
  totalTransactions: "Tổng giao dịch",
  totalUnspentCredits: "Tổng tín dụng chưa dùng",
  totalUnspentCreditsDesc: "Tổng tín dụng chưa dùng của khách liên kết với {0} và có lịch check-out trong khoảng ngày của bộ lọc ở trên.",
  totalUse: "Tổng lượt dùng",
  totalVisits: "Tổng lượt ghé thăm {0}",
  toViewDetailedInstructions: "Để xem hướng dẫn chi tiết",
  trackAndManage: "Theo dõi và quản lý các lần kiểm đếm kho thủ công.",
  trackedInventory: "Kho được theo dõi",
  trackEveryGuestCheckedIn: "Theo dõi mọi khách đã check-in tại địa điểm và xem mặt hàng, vị trí yêu thích của họ",
  trackWhichItemsLow: "Theo dõi mặt hàng sắp hết và cần bổ sung",
  tradeTypeTransactionNumber: "Số GD {0}",
  transaction: "Giao dịch",
  transactionId: "Mã giao dịch",
  transactionInfoPage: "Trang thông tin giao dịch",
  transactions: "Giao dịch",
  transactionsFailedToProcess: "giao dịch xử lý thất bại.",
  transactionsPage: "Trang giao dịch",
  transactionStatus: "Trạng thái giao dịch",
  transactionType: "Loại giao dịch",
  transfer: "Chuyển kho",
  transferSupplyItems: "Chuyển hàng tồn kho",
  transferSupplyItemsSuccessfully: "Chuyển hàng tồn kho thành công",
  transferSupplyItemsTxtConfirm: "Bạn có chắc muốn chuyển hàng tồn kho từ {0} sang {1}?",
  transferTo: "Chuyển đến",
  try: "Thử:",
  turnOffPos: "Tắt bán {0} {1}?",
  turnOnPos: "Bật bán {0} {1}?",
  txnId: "Mã GD: #",
  type: "Loại",
  typeAnOption: "Nhập một tùy chọn",
  typeAQuestion: "Nhập câu hỏi",
  typeAReason: "Nhập lý do...",
  typeDisconnect: "Nhập DISCONNECT bằng chữ in hoa để xác nhận",
  typeHere: "Nhập tại đây...",
  typeToSearch: "Nhập để tìm mặt hàng!",
  typeToSetAccountCode: "Nhập để đặt/chọn mã tài khoản.",
  unableToDelete: "Không thể xóa",
  unableToLoadTheMap: "Không thể tải bản đồ. Vui lòng kiểm tra kết nối internet và thử lại.",
  unableToValidateTheFile: "Không thể xác thực tệp.",
  unbaleToUploadMoreThanMb: "Không thể tải lên ảnh lớn hơn 1MB.",
  unban: "Bỏ chặn",
  unbanningWillMakeTagAccessible: "Bỏ chặn sẽ cho phép thẻ này sử dụng lại tại địa điểm của bạn.",
  unbanTag: "Bỏ chặn thẻ",
  unbill: "Hủy xuất hóa đơn",
  uncategorized: "Chưa phân loại",
  undefinedError: "Lỗi không xác định",
  undefinedErrorPlsTryAgain: "Lỗi không xác định. Vui lòng tải lại trang và thử lại",
  undo: "HOÀN TÁC",
  unignore: "Bỏ bỏ qua",
  unignoreAllOpenShifts: "Bỏ bỏ qua tất cả ca đang mở",
  unignoreAllShifts: "Bỏ bỏ qua tất cả ca",
  unitPrice: "Đơn giá",
  unitSold: "Số lượng đã bán",
  unitsSold: "Số lượng đã bán",
  unknown: "Không xác định",
  unspentCredit: "Tín dụng chưa dùng",
  updatedOn: "cập nhật lúc {0}",
  updatedFrom: "Cập nhật từ",
  transferFrom: "Chuyển từ",
  updatedVersionOfTheAppIsNowAvailable: "Đã có phiên bản ứng dụng mới!",
  upgradeNow: "Nâng cấp ngay",
  upgradePlanHeader: "Tăng sức mạnh cho địa điểm và sử dụng thêm nhiều tính năng cao cấp khi nâng cấp gói ngay hôm nay!",
  upgradeYourPlan: "Nâng cấp gói của bạn! ✨",
  upload: "Tải lên",
  uploadExcelFileToImport: "Tải lên tệp Excel để nhập",
  uploadPhoto: "Tải ảnh lên",
  uponRegistration: "khi đăng ký hoặc tại bất kỳ nhân viên / kiosk nạp tiền nào trong địa điểm.",
  upToDate: "Đã cập nhật",
  usage: "Mức sử dụng",
  usageDatePeriod: "Thời gian sử dụng",
  used: "Đã dùng",
  user: "Người dùng",
  username: "Tên đăng nhập",
  usesLastIssuedTo: "lượt dùng, phát hành gần nhất cho",
  useThisVenueDetails: "Dùng thông tin địa điểm này",
  useVenueAppAndLogin: "Sử dụng ứng dụng và đăng nhập bằng thẻ NFC đã kích hoạt hoặc tên đăng nhập và mật khẩu hiện tại.",
  usingTheURL: "Sử dụng URL",
  usingTheURLdesc: "Mở trình duyệt web, dán URL được cung cấp vào thanh địa chỉ và nhấn Enter để mở trang ứng dụng trên Google Play Store.",
  validUntilWithColonSymbol: "Có hiệu lực đến:",
  value: "Giá trị",
  valueBetween: "Giá trị phải trong khoảng",
  valueCanStillChangeTooltip: "Giá trị này vẫn có thể thay đổi nếu khách vẫn đang sử dụng tín dụng tại cơ sở của bạn.",
  valueRedeemed: "Giá trị đã đổi",
  values: "giá trị",
  variant: "Biến thể",
  variantAlreadyExist: "Biến thể đã tồn tại",
  variantIsCurrentlyBeingUsed: "Biến thể đang được sử dụng trong mặt hàng sau",
  variants: "Biến thể",
  vatReg: "Mã số thuế",
  venue: "Địa điểm",
  venueCurrency: "Tiền tệ của địa điểm",
  venueDashboard: "Trang quản trị địa điểm",
  venueDetails: "Thông tin địa điểm",
  venueInformation: "Thông tin địa điểm",
  venueInLitePlan: "Địa điểm này hiện đang dùng gói Lite.",
  venueLocation: "Vị trí địa điểm",
  venueLogo: "Logo địa điểm",
  venueMode: "Chế độ địa điểm",
  venueName: "Tên địa điểm",
  venueNameAlreadyExist: "Tên địa điểm đã tồn tại, vui lòng chọn tên khác",
  venueSettings: "Cài đặt địa điểm",
  venueSuspended: "Địa điểm bị tạm ngưng",
  veryHighDenominations: "Mệnh giá rất cao",
  view: "Xem",
  viewAccountOnSiigo: "Xem tài khoản trên Siigo",
  viewAllTransactions: "Xem tất cả giao dịch",
  viewAndExportDiscountReport: "Xem và xuất danh sách giảm giá cùng tổng số tiền đã giảm cho từng chương trình",
  viewAndExportEachClosedRegister: "Xem và xuất từng báo cáo ca đã đóng của nhân viên",
  viewAndExportFreeCreditsReport: "Xem và xuất tín dụng miễn phí đã cấp và đã xóa.",
  viewAndExportSalesReportByCategories: "Xem và xuất báo cáo doanh thu theo danh mục",
  viewAndExportVoucherReport: "Xem và xuất tất cả voucher đã áp dụng cho mặt hàng được đổi cùng tổng giá trị bán lẻ và nguyên liệu đã đổi theo từng voucher",
  viewBasicSummary: "Xem tóm tắt cơ bản",
  viewBillingStatement: "Xem sao kê thanh toán",
  viewBookingInfo: "Xem thông tin đặt chỗ từ các nền tảng khác nhau như MEWS, SoCashless Ticketing và nhiều hơn nữa!",
  viewBy: "Xem theo",
  viewCategoryDetails: "Xem chi tiết danh mục",
  viewDetails: "Xem chi tiết",
  viewDevice: "Xem thiết bị",
  viewDiscountDetails: "Xem chi tiết giảm giá",
  viewEveryTransactions: "Xem mọi giao dịch thực hiện tại địa điểm trong một khoảng thời gian",
  viewFullDetails: "Xem đầy đủ chi tiết",
  viewInfo: "Xem thông tin",
  viewIntegrations: "Xem tích hợp",
  viewInvoice: "Xem hóa đơn",
  viewListInvoiceTitle: "Xem danh sách hóa đơn của khách đã check-out tại địa điểm",
  viewNOfNTransactions: "Xem {0} / {1} giao dịch",
  viewNTransactions: "Xem {0} giao dịch",
  viewPaymentGateway: "Xem cổng thanh toán",
  viewPlansAndPricing: "Xem gói và bảng giá",
  viewPreview: "Xem trước",
  viewPrinter: "Xem máy in",
  viewTaxSettings: "Xem cài đặt thuế",
  viewTheSalesSummaryOfYourVenue: "Xem tóm tắt doanh thu của địa điểm cùng các vị trí, mặt hàng hàng đầu và nhiều hơn nữa.",
  viewVoucherDetails: "Xem chi tiết voucher",
  void: "Hủy",
  voidAuthorization: "Phê duyệt hủy",
  voidConfirmation: "Bạn có chắc muốn hủy {0}? Hành động này không thể hoàn tác.",
  voided: "Đã hủy",
  voidedBy: "Hủy bởi",
  voidedItems: "Mặt hàng đã hủy",
  voidedOn: "Hủy lúc",
  voidedValue: "Giá trị đã hủy",
  voidId: "Hủy {0}?",
  paymentInfo: "Thông tin thanh toán",
  includedServiceCharge: "Đã bao gồm phí dịch vụ.",
  voidInfo: "Thông tin hủy",
  voidReason: "Lý do hủy",
  voids: "Giao dịch hủy",
  voidStocktake: "Hủy phiếu kiểm kho",
  voucher: "Voucher",
  voucherItemName: "({0}x Voucher) {1}",
  voucherApplied: "Đã áp dụng voucher",
  voucherAvailable: "Voucher này có thể phát hành tại địa điểm của bạn.",
  voucherCreated: "Đã thêm {0}.",
  voucherDeleted: "Đã xóa voucher \"{0}\".",
  voucherIssue: "Phát hành voucher",
  voucherMovementPage: "Trang biến động voucher",
  voucherName: "Tên voucher",
  voucherNameAlreadyExist: "Tên voucher này đã tồn tại.",
  voucherReachedIssuanceLimit: "Voucher này đã đạt giới hạn phát hành tối đa là {0}.",
  voucherRemove: "Xóa voucher",
  voucherReport: "Báo cáo voucher",
  voucherRetailValue: "Giá trị bán lẻ của voucher",
  vouchers: "Voucher",
  vouchersCreationLimitInfo: "Bạn chỉ có thể tạo tối đa 8 voucher cho mỗi địa điểm. Bạn có thể xóa voucher hết hạn hoặc không hoạt động để tạo thêm.",
  vouchersIssued: "Voucher đã phát hành",
  vouchersListPage: "Trang danh sách voucher",
  vouchersMaximumNumberReached: "Đã đạt số lượng voucher tối đa.",
  vouchersRedeemed: "Voucher đã đổi",
  vouchersRemoved: "Voucher đã xóa",
  voucherSupplyValue: "Giá trị nguyên liệu của voucher",
  vouchersUsage: "Mức sử dụng voucher",
  voucherType: "Loại voucher",
  voucherUpdated: "Đã lưu thay đổi.",
  warning: "Cảnh báo",
  warningResyncDesc: "Vẫn còn giao dịch bị thiếu trong hệ thống hóa đơn điện tử do thiết bị ngoại tuyến.\nVui lòng đảm bảo tất cả thiết bị tại địa điểm đã kết nối internet và đã đẩy dữ liệu lên hệ thống để hoàn tất đồng bộ, sau đó nhấn nút “Đồng bộ lại hóa đơn điện tử” để cập nhật hóa đơn. ",
  warningSiigoIntegrationDesc: "Để tuân thủ quy định của Dian, bắt buộc phải thu thập các thông tin sau của khách: Tên, Email, Loại giấy tờ và Số giấy tờ.\nKhi tích hợp với Siigo, các câu hỏi này sẽ tự động xuất hiện trong hồ sơ khách.\n\nVui lòng không bỏ chọn để đảm bảo thu thập đầy đủ dữ liệu cần thiết khi check-in. Chúng tôi không chịu trách nhiệm cho bất kỳ thông tin nào bị thiếu do không tuân thủ.\n\n",
  weBuildCustomIntegrations: "Chúng tôi xây dựng tích hợp tùy chỉnh với các hệ thống hiện có của bạn. Hãy cho chúng tôi biết bạn cần gì.",
  weDidNotFoundReports: "Không tìm thấy báo cáo nào với bộ lọc của bạn.",
  wednesday: "Thứ Tư",
  week: "Tuần",
  weekMon2Sun: "Hằng tuần (Thứ Hai đến Chủ Nhật)",
  weeksAfterCheckout: "tuần sau khi check-out",
  weekSun2Sat: "Hằng tuần (Chủ Nhật đến Thứ Bảy)",
  weightInGrams: "Khối lượng (gam)",
  welcomeBack: "Chào mừng trở lại!",
  whatAreFreePostpaidCredits: "Tín dụng miễn phí và tín dụng trả sau là gì?",
  whenAnItemAlertLevel: "Khi mặt hàng giảm xuống mức cảnh báo.",
  whole: "Hoàn chỉnh",
  wholeProduct: "Mặt hàng hoàn chỉnh",
  withPendingPayments: "Có thanh toán đang chờ",
  withRemainingBalance: "Còn số dư",
  wouldReadOrWrite: "{0} sẽ đọc và/hoặc ghi các thông tin sau:",
  wristbandKeeping: "Giữ vòng đeo tay",
  wristbandTag: "Thẻ vòng đeo tay",
  wristbandTagKeeping: "Giữ thẻ vòng đeo tay",
  wristbandTagSettings: "Cài đặt thẻ vòng đeo tay",
  xByHourOfDay: "{0} theo giờ trong ngày",
  xConnectedFailed: "Không thể nhận diện mã truy cập này. Vui lòng tham khảo hướng dẫn bên dưới để lấy đúng mã truy cập.",
  xConnectedSuccessfully: "Kết nối {0} thành công",
  xIntegration: "Tích hợp {0}",
  xOverTime: "{0} theo thời gian",
  xY: "{0} {1}",
  year: "năm",
  years: "năm",
  yes: "Có",
  yesterday: "Hôm qua",
  youAreAboutToDelete: "Bạn sắp xóa {0} \"{1}\". Hành động này không thể hoàn tác.",
  youAreAboutToDeleteAQuestionThatIsLinked: "Bạn sắp xóa một câu hỏi đang liên kết với hồ sơ khách. Hành động này không thể hoàn tác.",
  youAreAboutToDeleteGuestProfile: "Bạn sắp xóa hồ sơ khách này. Hành động này không thể hoàn tác.",
  youAreAboutToDeleteMultiple: "Bạn sắp xóa {0} {1}. Hành động này không thể hoàn tác.",
  youAreAboutToDeletePaymentMethod: "Bạn sắp xóa phương thức thanh toán “{0}“.",
  youAreAboutToDeleteQuestion: "Bạn sắp xóa câu hỏi này. Hành động này không thể hoàn tác.",
  youAreAboutToDeleteStaffName: "Bạn sắp xóa {0} khỏi danh sách nhân viên. Nhân viên này sẽ không còn quyền truy cập {1}. Hành động này không thể hoàn tác.",
  youAreAboutToDeleteStaffProfile: "Bạn sắp xóa hồ sơ nhân viên này. Hành động này không thể hoàn tác.",
  youAreAboutToDeleteTax: "Bạn sắp xóa thuế “{0}“.",
  youAreAboutToDisconnect: "Bạn sắp ngắt kết nối và xóa vĩnh viễn mọi thông tin khỏi ứng dụng này.",
  youAreAboutToRemoveFromMailingList: "Bạn sắp xóa {0} khỏi danh sách nhận email này. Tài khoản này sẽ không nhận được cảnh báo mức tồn kho.",
  youAreAboutToRemoveMultipleProduct: "Bạn sắp xóa {0} mặt hàng và các biến thể khỏi kho và tất cả vị trí. Hành động này không thể hoàn tác.",
  youAreAboutToRemoveProduct: "Bạn sắp xóa mặt hàng này khỏi kho và tất cả vị trí. Hành động này không thể hoàn tác.",
  youAreAboutToRemoveVariantProduct: "Bạn sắp xóa mặt hàng này và {0} biến thể khỏi kho và tất cả vị trí. Hành động này không thể hoàn tác.",
  youAreAssigned: "Bạn được gán các vai trò sau:",
  youAreLoggedInAs: "Bạn đang đăng nhập với tư cách {0}",
  youCanChangeThisLater: "Bạn có thể thay đổi sau!",
  youCanFindMoreInformationAboutThisHere: "Bạn có thể tìm thêm thông tin tại đây.",
  youCanNowLogin: "Bây giờ bạn có thể đăng nhập bằng email và mật khẩu.",
  youCanReviewQuestionInEachGuestProfile: " Bạn có thể xem lại câu hỏi trong từng hồ sơ khách ",
  youDontHavePermission: "Bạn không có quyền truy cập liên kết này",
  youHaveUnsavedChanges: "Bạn có thay đổi chưa lưu trên trang này.",
  youllFindYourBookingsHere: "Các lượt đặt chỗ của bạn sẽ hiển thị tại đây.",
  yourCurrentAssignedRoles: "Vai trò hiện tại của bạn là",
  yourGeneralSettings: "Cài đặt chung như tên địa điểm và tiền tệ.",
  yourMailingIsEmpty: "Danh sách nhận email của bạn vẫn trống.",
  yourSubscriptionCanceled: "Gói đăng ký {0} cho địa điểm {1} của bạn đã bị hủy.",
  yourSubscriptionEnded: "Gói đăng ký {0} cho địa điểm {1} của bạn đã kết thúc.",
  yourVenues: "Địa điểm của bạn",
  youveReachedTheEndOfTheList: "Bạn đã xem hết danh sách.",
  zeroInventory: "Tồn kho bằng 0",
  siigoCardDesc: "Siigo là phần mềm kế toán trực tuyến tiên tiến với công cụ xuất hóa đơn tuân thủ Dian, cần thiết để tối ưu hiệu quả và thúc đẩy tăng trưởng kinh doanh",
  youAreCurrentlyInSiigoEnv: "Bạn đang bật môi trường Siigo cho địa điểm này. Xin lưu ý cấu hình này không hỗ trợ tính năng 'Phụ phí'.",
  youAreEnablingSiigo: "Bạn đang bật môi trường Siigo cho địa điểm này. Xin lưu ý tính năng 'Phụ phí' không được hỗ trợ trong cấu hình này.",
  setToDefault: "Đặt làm mặc định",
  registerForRefund: "Đăng ký hoàn tiền",
  refund: "Hoàn tiền",
  refunds: "Hoàn tiền",
  onGroundReport: "Tóm tắt đăng ký đặt chỗ và ra vào",
  multipleInReport: "Vào nhiều lần",
  guestProfileId: "ID hồ sơ khách",
  totalSold: "Tổng đã bán",
  totalActivated: "Tổng đã kích hoạt",
  activePercentage: "% kích hoạt",
  totalAccessIn: "Tổng lượt vào",
  accessedPercentage: "% đã vào",
  notActivated: "Chưa kích hoạt",
  notActivatedPercentage: "% chưa kích hoạt",
  notAccessed: "Chưa vào",
  notAccessedPercentage: "% chưa vào",
  onGround: "Báo cáo tại sự kiện",
  inactiveBookingReport: "Tóm tắt đặt chỗ không hoạt động",
  transactionRefundReport: "Tổng hoàn tiền",
  topupAndSaleSummaryReport: "Tóm tắt nạp tiền và bán hàng",
  remainingBalanceReport: "Số dư ví còn lại",
  duplicateTicketsReport: "Báo cáo vé trùng lặp",
  enableKiosk: "Bật kiosk",
  connectSiigoToYourSocashlessAccount: "Kết nối {0} với tài khoản SoCashless của bạn.",
  totalDistinctWalletsUsedForTransactions: "Tổng số ví khác nhau đã dùng cho giao dịch",
  countOfWalletWithCashRemaining: "Số ví còn tiền",
  version: "Phiên bản",
  totalCheckIn: "Tổng check-in",
  totalTopUp: "Tổng nạp tiền",
  transactionLastSynced: "Giao dịch đồng bộ lần cuối",
  deviceSyncStatus: "Trạng thái đồng bộ thiết bị",
  ticketType: "Loại vé",
  topUpAndSalesSummaryReport: "Tóm tắt nạp tiền và doanh thu",
  totalRefundReport: "Tổng hoàn tiền",
  yourMightGetNegative: "Báo cáo được yêu cầu dành cho chế độ Sự kiện trong khi bạn đang ở chế độ Địa điểm.",
  maximumTopUp: "Nạp tối đa",
  mdr: "MDR",
  guestRefundReport: "Báo cáo hoàn tiền cho khách",
  guestRefundReportDesc: "Quản lý dữ liệu hoàn tiền cho khách tại sự kiện",
  tagUid: "UID thẻ",
  tagBalance: "Số dư",
  eventStartDateTime: "Ngày bắt đầu và kết thúc sự kiện",
  event: "Sự kiện",
  transactionStartDateTime: "Ngày bắt đầu và kết thúc giao dịch",
  refundStartDateTime: "Ngày bắt đầu và kết thúc hoàn tiền",
  mdrCharges: "Phí MDR",
  amountClaimed: "Số tiền yêu cầu",
  claimDate: "Ngày yêu cầu",
  claimStatus: "Trạng thái yêu cầu",
  refundClaimReport: "Báo cáo yêu cầu hoàn tiền",
  refundClaimReportDesc: "Quản lý dữ liệu yêu cầu hoàn tiền của khách tại sự kiện",
  refunded: "Đã hoàn tiền",
  registered: "ĐÃ ĐĂNG KÝ",
  exported: "Đã xuất",
  kiosk: "Kiosk",
  minimumTopUp: "Nạp tối thiểu",
  deviceLocation: "Vị trí thiết bị",
  connectToSiigo: "Kết nối với Siigo",
  connectToSiigoDesc: "Để sử dụng tích hợp Siigo, vui lòng liên hệ đội ngũ Quản trị để được cấp quyền.",
  totalDiscount: "Tổng giảm giá",
  eventTimeZone: "Múi giờ sự kiện",
  taxPercentage: "% thuế",
  searchByGuestNameEmailTagUid: "Tìm theo tên khách, Email/Điện thoại, UID thẻ",
  amountRecieved: "Số tiền đã nhận",
  gHL: "GHL",
  pendingUnbill: "Đang chờ đồng bộ giao dịch chưa xuất hóa đơn",
  cancelationReport: "Báo cáo hủy vé",
  cancelationReportDesc: "Xem danh sách vé đã hủy.",
  cancelTicket: "Hủy vé",
  ticketDetails: "Chi tiết vé",
  ticketCancelled: "Đã hủy vé",
  timeZone: "Múi giờ",
  isAppliedForStaff: "Áp dụng cho nhân viên",
  voucherId: "ID voucher",
  customerName: "Tên khách hàng",
  voucherTransaction: "Giao dịch voucher",
  topupVoucher: "Voucher nạp tiền",
  refundVoucher: "Voucher hoàn tiền",
  voucherDate: "Ngày voucher",
  guestTagUid: "UID thẻ khách",
  tagUseCount: "Số lần dùng thẻ",
  model: "Mẫu máy",
  osVersion: "Phiên bản hệ điều hành",
  firmwareVersion: "Phiên bản firmware",
  softwareVersion: "Phiên bản phần mềm",
  ghlVersion: "Phiên bản ứng dụng GHL",
  ttbVersion: "Phiên bản ứng dụng TTB",
  userDetails: "Thông tin người dùng đã đăng nhập",
  deviceRegisterDateTime: "Ngày giờ đăng ký thiết bị",
  deviceLastLocationDateTime: "Ngày giờ cập nhật vị trí gần nhất",
  mdmDeviceList: "Danh sách thiết bị MDM",
  mdmDeviceListDescription: "Xem và quản lý thông tin thiết bị MDM",
  mdm: "MDM",
  deviceGeoLocation: "Vị trí địa lý thiết bị",
  deviceGeoLocationDescription: "Xem vị trí thiết bị trên bản đồ tương tác",
  deviceLocationMap: "Bản đồ vị trí thiết bị",
  selectDeviceLocation: "Chọn vị trí thiết bị",
  showingDevicesOnMap: "Đang hiển thị thiết bị trên bản đồ",
  searchMdmDevices: "Tìm thiết bị MDM...",
  resyncVoucher: "Đồng bộ lại voucher",
  topup: "Nạp tiền",
  unsyncTransactionReports: "Báo cáo tình trạng PMS",
  count: "Số lượng",
  monthlySaleReport: "Báo cáo doanh thu hằng tháng",
  subscriptionPlanName: "Gói đăng ký",
  subscriptionCustomerId: "Mã khách hàng",
  allowNonNfcActivationProfile: "Cho phép kích hoạt không dùng NFC cho hồ sơ khách này",
  nonNfcActivation: "Kích hoạt không dùng NFC",
  adjustment: "Điều chỉnh",
  adjustmentVoucher: "Voucher điều chỉnh",
  importFile: "Nhập tệp (.xlsx)",
  importFail: "Nhập thất bại!",
  fileSizeExceeded: "Kích thước tệp vượt quá giới hạn cho phép {0}. Vui lòng chia dữ liệu thành hai tệp và sử dụng tính năng tải lên bổ sung để tiếp tục.",
  invalidBookingFileType: "Định dạng tệp không hợp lệ. Chỉ hỗ trợ nhập tệp {0}. Vui lòng tải lên tệp {1} hợp lệ và thử lại.",
  selectImportType: "Chọn kiểu nhập",
  selectImportTypeDesc: "Bạn đang thực hiện nhập bổ sung hay nhập mới?",
  incremental: "Bổ sung",
  newBookingDataImport: "{0} bản ghi dữ liệu hiện có sẽ bị xóa và {1} bản ghi mới sẽ được tải lên. Bạn vẫn muốn tiếp tục?",
  topUpType: "Nạp tiền",
  refundType: "Hoàn tiền",
  documentType: "Loại chứng từ",
  selectTopupType: "Chọn loại nạp tiền",
  selectRefundType: "Chọn loại hoàn tiền",
  outletName: "Tên vị trí",
  createOutlet: "Tạo vị trí",
  editOutlet: "Sửa vị trí",
  deleteOutlet: "Xóa vị trí",
  arrivalTime: "Giờ đến",
  arrivalTimeReport: "Báo cáo giờ đến",
  arrivalTimeStatisticView: "Thống kê giờ đến",
  arrivalTimeStatisticViewDesc: "Theo dõi lượt khách dự kiến đến và tỷ lệ hoàn thành biểu mẫu theo giờ đến.",
  guestsByArrivalTime: "Khách theo giờ đến",
  arrivalTimeSummary: "Tóm tắt giờ đến",
  guestRegistration: "Đăng ký khách",
  registeredGuests: "Khách đã đăng ký",
  totalGuests: "Tổng số khách",
  guestCount: "Số lượng khách",
  peakHour: "Giờ cao điểm",
  bothGuestTypes: "Cả hai",
  noArrivalTimeData: "Không có lượt khách đến nào trong ngày này.",
  topupAccount: "Nạp tiền",
  refundAccount: "Hoàn tiền",
  invoiceAccount: "Hóa đơn",
  filter: "Bộ lọc",
  clearAll: "Xóa tất cả",
  apply: "Áp dụng",
  pickADate: "Chọn ngày",
  last7Days: "7 ngày qua",
  last30Days: "30 ngày qua",
  last90Days: "90 ngày qua",
  customRange: "Khoảng tùy chỉnh",
  totalReservedGuests: "Tổng khách đã đặt chỗ",
  totalPreCheckinGuests: "Tổng khách đã check-in trước",
  waitForPreCheckinGuests: "Khách chờ check-in trước",
  zeusDescription: "Quản lý cơ sở lưu trú dành cho mô hình lưu trú cộng đồng quy mô lớn.",
  reservationCode: "Mã đặt chỗ",
  reservationDetails: "Chi tiết đặt chỗ",
  reservationNo: "Số đặt chỗ",
  reservationSummary: "Tóm tắt đặt chỗ",
  formCompletion: "Hoàn thành biểu mẫu",
  manifestPublicLink: "Liên kết công khai danh sách khách",
  identificationType: "Loại giấy tờ tùy thân",
  idNumber: "Số giấy tờ",
  idScan: "Ảnh giấy tờ",
  medicalCondition: "Tình trạng sức khỏe",
  foodAllergies: "Dị ứng thực phẩm",
  specialNotes: "Ghi chú đặc biệt",
  freeCredit: "Tín dụng miễn phí",
  guestNumber: "Khách {0}",
  seatsForZone: "{0} chỗ cho {1}",
  seatsQuantity: "{0} chỗ",
  clickHereLink: "Nhấn vào đây",
  zone: "Khu vực",
  ticket: "Vé",
  passport: "Hộ chiếu",
  nationalIdentificationCard: "Căn cước công dân",
  drivingLicense: "Giấy phép lái xe",
  package: "Gói",
  reservationOriginalFreeCredit: "Tín dụng miễn phí ban đầu của đặt chỗ",
  forgotPassword: "Quên mật khẩu?",
  forgotYourPassword: "Bạn quên mật khẩu?",
  enterEmailToResetPassword: "Nhập địa chỉ email liên kết với tài khoản và chúng tôi sẽ gửi liên kết để đặt lại mật khẩu.",
  sendResetLink: "Gửi liên kết đặt lại",
  emailNotFoundInSystem: "Không tìm thấy tài khoản với email này.",
  resetPasswordEmailSentTo: "Chúng tôi đã gửi liên kết đặt lại mật khẩu tới {0}.",
  backToLogin: "Quay lại đăng nhập",
  resetPassword: "Đặt lại mật khẩu",
  enterNewPassword: "Nhập mật khẩu mới cho tài khoản của bạn.",
  passwordResetSuccessfully: "Mật khẩu của bạn đã được đặt lại. Bây giờ bạn có thể đăng nhập.",
  resetPasswordFailed: "Không thể đặt lại mật khẩu. Liên kết có thể không hợp lệ hoặc đã hết hạn.",
  invalidResetPasswordLink: "Liên kết đặt lại mật khẩu này không hợp lệ.",
};

export default Object.freeze(locale);
